// ArChat Language Extension
// Created: 14-03-2026 16:10:00
// Author: SIVOL® - Aldo Frias - Argentina

import { translationsEn } from './translations.en.js';
import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsSv = {
  ...translationsEn,
  'common.close': 'Stäng',
  'common.cancel': 'Avbryt',
  'common.language': 'Språk',
  'home.language': 'Språk',
  'profile.language': 'Språk',
  'menu.contacts': 'Kontakter',
  'navbar.contacts': 'Kontakter',
  'contacts.title': 'Kontakter',
  'contacts.search': 'Sök kontakt',
  'contacts.sort': 'Sortera',
  'contacts.sortByName': 'Efter namn',
  'contacts.sortByStatus': 'Efter status',
  'contacts.sortByRecent': 'Senaste',
  'contacts.filter': 'Filtrera',
  'contacts.filterAll': 'Alla',
  'contacts.filterAvailable': 'Tillgängliga',
  'contacts.filterInvited': 'Inbjudna',
  'contacts.filterBlocked': 'Blockerade',
  'contacts.pending_invitations': 'Väntande inbjudningar',
  'contacts.status.invitation_sent': 'Inbjudan skickad',
  'contacts.no_contacts': 'Inga kontakter',
  'contacts.invite_contact': 'Bjud in kontakt',
  'contacts.conversations': 'Konversationer',
  'contacts.search_contact': 'Sök kontakt',
  'menu.dashboard': 'Instrumentpanel',
  "dashboard.title": "Instrumentpanel",
  'dashboard.planUsage': 'Plånutnyttjande',
  'dashboard.filesSummary': 'Mina filer',
  'dashboard.promotions': 'Kampanjer',
  'dashboard.sessions': 'Aktiva sessioner',
  'dashboard.explore': 'Utforska',
  'dashboard.noSessions': 'Inga aktiva sessioner',
  'dashboard.welcomeTitle': 'Välkommen till ArChat®',
  'dashboard.welcomeSubtitle': 'Chatta på vilket språk som helst.',
  'dashboard.stepInvite': 'Steg 1: bjud in din första kontakt',
  'dashboard.stepMessage': 'Steg 2: skicka ditt första meddelande',
  'dashboard.inviteContact': 'Bjud in kontakt',
  'dashboard.exploreArChat': 'Utforska ArChat',
  'dashboard.promotionsTitle': 'Kampanjer',
  'dashboard.promotionsText': 'Översikt av hänvisnings- och belöningsprogrammet.',
  'dashboard.viewPromotions': 'Visa kampanjer',
  'dashboard.usageTitle': 'Plånutnyttjande',
  'dashboard.sessionsTitle': 'Aktiva sessioner',
  'dashboard.sessionsEmpty': 'Inga aktiva sessioner',
  'dashboard.filesTitle': 'Mina filer',
  'dashboard.viewFiles': 'Visa mina filer',
  'dashboard.noBlocks': 'Inga block aktiverade. Slå på minst ett under Inställningar.',
  'dashboard.openSettings': 'Öppna inställningar',
  'dashboard.goToContacts': 'Gå till kontakter',
  'dashboard.filesVisible': 'Synliga filer',
  'dashboard.filesSampleNote': 'Antal från första sidan (upp till 500+).',
  'dashboard.card.contacts': 'Kontakter',
  'menu.help': 'Hjälp',
  'help.title': 'ArChat® Hjälp',
  "navbar.status": "Ange",
  'status.available': 'Tillgänglig',
  'status.busy': 'Upptagen',
  'status.in_call': 'I samtal',
  'status.away': 'Borta',
  "status.offline": "Off-line",
  'status.custom': 'Anpassat meddelande',
  'status.set_title': 'Tillganglighetsstatus',
  'status.set_button': 'Andra status',
  'status.placeholder': 'Valfritt meddelande (t.ex. I mote)',
  'presence.title': 'Narvarostatus',
  'presence.currentStatus': 'Aktuell status:',
  'presence.changeStatus': 'Andra status',
  "presence.status.online": "Online",
  'presence.status.online.title': 'Online - Synlig for alla',
  'presence.status.online.description': 'Online: Synlig for alla kontakter',
  'presence.status.idle': 'Inaktiv',
  'presence.status.idle.title': 'Inaktiv - Indikerar tillfallig franvaro',
  'presence.status.idle.description': 'Inaktiv: Indikerar att du tillfalligt inte ar tillganglig',
  'presence.status.dnd': 'Stor ej',
  'presence.status.dnd.title': 'Stor ej - Indikerar att du foredrar att inte bli avbruten',
  'presence.status.dnd.description': 'Stor ej: Synlig signal att du foredrar att inte bli avbruten',
  'presence.status.busy': 'Upptagen',
  'presence.status.busy.title': 'Upptagen - Inte tillganglig',
  'presence.status.busy.description': 'Upptagen: Inte tillganglig',
  "presence.status.offline": "Off-line",
  'presence.status.offline.title': 'Frankopplad - Visa som offline',
  'presence.status.offline.description': 'Offline: Visa som fran kopplad',
  'presence.status.custom': 'Anpassad',
  'presence.status.custom.title': 'Anpassad - Unik status med emoji',
  'presence.status.custom.description': 'Anpassad: Unik status med emoji och valfri utgangstid',
  'presence.custom.title': 'Anpassad status',
  'presence.custom.status': 'Anpassad status',
  'presence.custom.placeholder': 'T.ex.: Tar en kaffe ☕',
  'presence.custom.emoji': 'Emoji (valfritt)',
  'presence.custom.emojiHelp': 'Valj en emoji eller skriv en',
  'presence.custom.temporary': 'Tillfallig status (gar ut automatiskt)',
  'presence.custom.expiration': 'Utgangsdatum',
  'presence.custom.expirationHelp': 'Statusen atergar till "Online" nar den gar ut',
  'presence.custom.suggestions': 'Forslag',
  'presence.custom.preview': 'Forhandsvisning',
  'presence.custom.save': 'Spara status',
  'presence.custom.required': 'Anpassad status ar obligatorisk',
  'presence.custom.maxLength': 'Max 64 tecken',
  'presence.custom.expirationRequired': 'Du maste valja ett utgangsdatum',
  'presence.custom.expirationFuture': 'Utgangsdatum maste ligga i framtiden',
  'presence.custom.selectEmoji': 'Valj emoji',
  'presence.unavailable': 'Status ar inte tillgangliga',
  'presence.maintenance': 'Servern ar under underhall',
  'menu.profile': 'Min profil',
  'profile.my_profile': 'Min profil',
  'profile.status': 'Läge',
  'profile.invite_email': 'Bjud in kontakt via e-post',
  'profile.sent_invitations': 'Skickade inbjudningar',
  'profile.logout': 'Logga ut',
  'profile.title': 'Min profil',
  'menu.logout': 'Logga ut',
  'menu.files': 'Mina filer',
  'reviews.menu_title': 'Omdömen',
  'reviews.rate_archat': 'Betygsätt ArChat',
  'reviews.my_review': 'Mitt omdöme',
  'invitation.title': 'Bjud in kontakt via e-post',
  'invitation.modal.title': 'Skicka inbjudan',
  'invitation.modal.description': 'Bjud in någon att chatta med dig på ArChat®. Personen får ett e-postmeddelande med en länk för att acceptera inbjudan.',
  'invitation.email.label': 'Inbjudens e-post',
  'invitation.email.required': 'E-post är obligatoriskt',
  'invitation.email.invalid': 'Ange en giltig e-postadress',
  'invitation.language.label': 'Inbjudens föredragna språk',
  'invitation.language.help': 'E-postmeddelandet skickas på detta språk',
  'invitation.mode.label': 'Samtalsläge',
  'invitation.mode.profesional': 'Professionellt',
  'invitation.mode.profesional.description': 'Formellt och professionellt samtal',
  'invitation.mode.tecnico': 'Tekniskt',
  'invitation.mode.tecnico.description': 'Tekniskt och specialiserat samtal',
  "invitation.mode.casual": "Tillfällig",
  'invitation.mode.casual.description': 'Informellt och vänligt samtal',
  'invitation.message.label': 'Personligt meddelande (valfritt)',
  'invitation.message.placeholder': 'Skriv ett personligt meddelande till den inbjudna...',
  'invitation.send': 'Skicka inbjudan',
  'invitation.sending': 'Skickar...',
  'invitation.success': 'Inbjudan skickades',
  'invitation.success.title': 'Inbjudan skickad',
  'invitation.error': 'Fel vid skickande av inbjudan',
  'invitation.list.title': 'Skickade inbjudningar',
  'invitation.list.empty': 'Du har inte skickat några inbjudningar än',
  'invitation.list.email': 'E-post',
  'invitation.list.language': 'Språk',
  'invitation.list.mode': 'Läge',
  "invitation.list.status": "Ange",
  'invitation.list.created': 'Skickad',
  'invitation.list.expires': 'Upphör',
  'invitation.list.actions': 'Åtgärder',
  'invitation.status.pending': 'Väntande',
  'invitation.status.accepted': 'Accepterad',
  'invitation.status.expired': 'Utgången',
  'invitation.status.cancelled': 'Avbruten',
  'invitation.cancel': 'Avbryt',
  'invitation.cancel.confirm': 'Är du säker på att du vill avbryta den här inbjudan?',
  'invitation.cancel.success': 'Inbjudan avbröts',
  'invitation.cancel.title': 'Bekräfta avbryt',
  'invitation.resend': 'Skicka e-post igen',
  'invitation.resend.title': 'Skicka inbjudan igen',
  'invitation.resend.success': 'Inbjudningsmail skickades igen',
  'invitation.resend.error': 'Fel vid omskick av inbjudningsmail',
  'invitations.pending.title': 'Väntande inbjudningar',
  'invitations.sent.title': 'Skickade inbjudningar',
  'navbar.users': 'Användare',
  'menu.settings': 'Inställningar',
  'suggestions.title': 'Förslag',
  'suggestions.form.title': 'Förslagstitel',
  'suggestions.form.message': 'Beskriv din idé',
  'suggestions.form.submit': 'Skicka förslag',
  'suggestions.send': 'Skicka förslag',
  'suggestions.captcha_placeholder': 'Resultat',
  'suggestions.cooldown': 'Du måste vänta {minutes} minuter innan du skickar ett nytt förslag.',
  'suggestions.success_title': 'Förslag skickat',
  'suggestions.success_message': 'Ditt förslag har skickats. Spårningsnummer: {id}',
  'suggestions.success': 'Tack för ditt förslag. Vårt team kommer att granska det.',
  'suggestions.success.title': 'Tack för ditt förslag!',
  'suggestions.success.reference': 'Referens',
  'suggestions.success.review': 'Vårt team kommer att granska din idé.',
  'suggestions.success.email': 'Vi har även skickat ett bekräftelsemail till dig.',
  'suggestions.success.copy': 'Kopiera',
  'suggestions.success.copied': 'Referens kopierad',
  'suggestions.form.required': 'Titel och meddelande är obligatoriska.',
  'suggestions.error': 'Kunde inte skicka. Försök igen.',
  'suggestions.sendSuccess': 'Ditt förslag har skickats.',
  'suggestions.sendError': 'Det gick inte att skicka förslaget. Försök igen.',
  'suggestions.sent': 'Förslaget skickades.',
  'suggestions.new': 'Nytt förslag',
  'suggestions.empty': 'Du har inte skickat några förslag ännu.',
  'suggestions.admin_note': 'Teamanteckning',
  'suggestions.status.pending': 'Väntande',
  'suggestions.status.reviewed': 'Granskat',
  'suggestions.status.planned': 'Planerat',
  'suggestions.status.implemented': 'Implementerat',
  'suggestions.status.rejected': 'Avvisat',
  'errors.suggestionSend': 'Det gick inte att skicka förslaget. Försök igen.',
  'contacts.controls.search_placeholder': 'Sök kontakt...',
  'contacts.controls.search_label': 'Sök kontakt',
  'contacts.controls.sort_label': 'Sortera efter',
  'contacts.controls.sort.name': 'Namn',
  "contacts.controls.sort.status": "Ange",
  'contacts.controls.sort.recent': 'Senaste',
  'contacts.controls.sort.manual': 'Manuellt',
  'contacts.controls.sort.manual_drag_hint': 'Dra för att ordna om',
  "contacts.controls.filter_label": "Ange",
  'contacts.controls.filter.all': 'Alla',
  'contacts.controls.filter.available': 'Tillgängliga',
  'contacts.controls.filter.invited': 'Inbjudna',
  'contacts.controls.filter.blocked': 'Blockerade',
  'contacts.controls.filter.favorites': 'Favoriter',
  'promotions.invite.message': 'Jag inbjuder dig till ArChat – tala på vilket språk som helst. Vi får båda fördelar.',
  'promotions.progress.pending': 'Du har väntande inbjudningar för att låsa upp belöningar.',
  'promotions.progress.in_progress': 'Dina inbjudningar pågår: belöningar aktiveras efter en riktig konversation.',
  'promotions.progress.remaining': 'Du behöver {count} konversation till för att få din belöning.',
  'promotions.progress.sent_count': 'Skickat',
  'promotions.progress.pending_count': 'I avvaktan på',
  'promotions.progress.in_progress_count': 'Pågår',
  'promotions.progress.completed_count': 'Avslutad',
  'promotions.banner.empty': 'Börja nu: bjud in kontakter och lås upp förmåner.',
  'promotions.banner.pending': 'Du har väntande inbjudningar: slutför en riktig konversation och tjäna belöningar.',
  'promotions.banner.reward': 'Du har redan låst upp belöningar! Fortsätt bjuda in för att öka dina vinster.',
  'promotions.cta.copy': 'Kopiera meddelande och länk',
  'promotions.cta.copied': 'Meddelandet har kopierats',
  'promotions.cta.copy_error': 'Det gick inte att kopiera meddelandet',

  'promotions.title': 'Kampanjer och belöningar',
  'promotions.subtitle': 'Bjud in kontakter och lås upp fördelar genom verklig användning.',
  'promotions.how_it_works': 'Hur det fungerar',
  'promotions.step1': 'Bjud in en kontakt från din profil.',
  'promotions.step2': 'När de accepterar och chattar med verklig interaktion, valideras det automatiskt.',
  'promotions.step3': 'Belöningen krediteras och dina framsteg uppdateras.',
  'promotions.rewards.title': 'Belöningar',
  'promotions.reward.invite': 'Belöning för varje validerad remiss.',
  'promotions.reward.milestone': 'Bonusar för tillväxtmilstolpar.',
  'promotions.reward.ranking': 'Synlighet i topprankningen för nätverksbyggare.',
  'promotions.progress.title': 'Dina framsteg',
  'promotions.progress.sent': 'Skickat',
  'promotions.cta.invite': 'Bjud in kontakt',
  'promotions.banner': 'Aktivera kampanjer: bjud in och tjäna belöningar för verklig användning.',
  'promotions.modal.title': 'Kampanjprogram',
  'promotions.modal.body': 'Tjäna +10 000 tecken per validerad inbjudan.\\\\nBjud in idag och lås upp belöningar.',
  'promotions.modal.cta': 'Se kampanjer',
  'login.title': 'Logga in',
  'login.slogan': 'Samtal utan gränser!',
  'login.username': 'Användarnamn',
  'login.password': 'Lösenord',
  'login.submit': 'Logga in',
  'login.loading': 'Laddar...',
  'login.autoRegister.title': 'Automatisk registrering',
  'login.autoRegister.description': 'Om du inte har ett konto anger du användarnamn, lösenord och e-post. Det skapas automatiskt och du får en bekräftelselänk via e-post.',
  'login.forgotPassword': 'Glömt lösenordet?',
  'login.passwordRecovery.title': 'Återställ lösenord',
  'login.passwordRecovery.description': 'Ange din e-post för att få en återställningslänk.',
  'login.passwordRecovery.emailLabel': 'E-post',
  'login.passwordRecovery.emailPlaceholder': 'Ange din e-post',
  'login.passwordRecovery.emailHelp': 'En återställningslänk skickas till din e-post',
  'login.passwordRecovery.send': 'Skicka',
  'login.passwordRecovery.success': 'En återställningslänk har skickats till din e-post. Kontrollera inkorgen.',
  'login.passwordRecovery.successTitle': 'E-post skickad',
  'login.passwordRecovery.successMessage': 'Vi har skickat ett e-postmeddelande med instruktioner för att återställa lösenordet.\nKontrollera inkorgen och skräppostmappen. Länken kan ta några minuter.',
  'login.passwordRecovery.devExplanation': 'I utvecklingsläge skickas inte e-post till inkorgen; den sparas för förhandsvisning. Använd «Visa e-post» för att se innehållet och återställningslänken.',
  'login.passwordRecovery.devSinkNotice': '⚠️ Utvecklingsläge: detta e-postmeddelande skickades INTE till din inkorg. Använd «Visa e-post» för att öppna det genererade meddelandet och använda länken.',
  'login.passwordRecovery.invalidEmail': 'Ange en giltig e-postadress',
  'login.error.invalidPassword': 'Ogiltigt lösenord',
  'auth.require_email': 'E-post krävs för att slutföra registreringen. Ange din e-post.',
  'auth.invalid_credentials': 'Fel användarnamn eller lösenord.',
  'auth.user_not_found': 'Användaren hittades inte.',
  'auth.user_inactive': 'Ditt konto är avaktiverat. Kontakta administratören.',
  'auth.tenant_mismatch': 'Ditt konto tillhör inte den här miljön. Kontakta administratören.',
  'auth.account_blocked': 'Kontot är inaktivt. Ange din e-post för att återaktivera det.',
  'auth.device_limit_reached': 'Enhetsgräns nådd. Logga ut på en annan enhet eller uppgradera din plan.',
  'auth.login.device_limit.title': 'Sessions- eller enhetsgräns nådd',
  'auth.login.device_limit.body': 'Din plan tillåter ett begränsat antal aktiva sessioner eller enheter. Logga ut på en annan enhet eller avsluta en annan aktiv session och försök igen.',
  'auth.password_incorrect': 'Lösenordet är felaktigt.',
  'auth.login.password_error_title': 'Felaktigt lösenord',
  'auth.login.password_attempts_hint': 'Du har tre försök på dig att ange rätt lösenord. Om du överskrider dem måste du återställa lösenordet.',
  'auth.login.password_attempts_exhausted_title': 'Gränsen för försök har nåtts',
  'auth.login.password_attempts_exhausted_body': 'Du har överskridit de tre tillåtna försöken. Återställ lösenordet via «Glömt lösenord?» för att fortsätta.',
  'auth.login.go_to_reset_password': 'Gå till återställning av lösenord',
  'auth.login.password_remaining_two': 'Du har 2 försök kvar.',
  'auth.login.password_remaining_one': 'Du har 1 försök kvar.',
  'auth.login.password_attempts_locked_inline': 'Maximalt antal försök har nåtts. Du måste återställa ditt lösenord.',
  'auth.account_inactive_email_mismatch': 'Kontot är inaktivt och e-postadressen matchar inte.',
  'auth.captcha_failed': 'CAPTCHA är felaktig. Kontrollera ditt svar.',
  'auth.captcha_expired': 'Din verifiering har löpt ut. En ny har genererats automatiskt.',
  'auth.captcha_required': 'Slutför säkerhetsverifieringen (CAPTCHA).',
  'auth.unauthorized': 'Du har inte behörighet att komma åt detta.',
  'auth.generic_error': 'Ett fel inträffade. Försök igen.',
  'auth.method_not_allowed': 'Metoden är inte tillåten.',
  'auth.invalid_data': 'Ogiltiga data.',
  'auth.credentials_required': 'Användarnamn och lösenord krävs.',
  'auth.csrf_invalid': 'Ogiltig session. Ladda om sidan och försök igen.',
  'auth.username_taken': 'Det användarnamnet är redan registrerat. Logga in eller välj ett annat.',
  'auth.username_unavailable': 'Det användarnamnet är inte tillgängligt.',
  'auth.nick_no_spaces': 'Smeknamn får inte innehålla mellanslag.',
  'auth.password_too_short': 'Lösenordet måste vara minst 6 tecken.',
  'auth.password_mismatch': 'Lösenorden matchar inte.',
  'auth.rate_limit': 'För många försök. Vänta en stund och försök igen.',
  'auth.confirm_success': 'Kontot bekräftades. Omdirigerar till inloggning...',
  'auth.confirm_already_active': 'Ditt konto är redan aktivt. Du kan logga in.',
  'auth.reset_sent': 'Om e-postadressen är registrerad får du instruktioner för att återställa lösenordet.',
  'auth.reset_token_invalid': 'Ogiltig eller saknad länk.',
  'auth.reset_token_expired': 'Denna länk har löpt ut. Begär en ny via «Glömt lösenordet?».',
  'auth.reset_done': 'Lösenordet har uppdaterats. Du kan nu logga in.',
  'auth.reset_fatal': 'Fel vid sparande. Försök igen senare.',
  'resetPassword.page.title': 'Nytt lösenord',
  'resetPassword.page.description': 'Ange ditt nya lösenord (minst 6 tecken).',
  'resetPassword.newPassword': 'Nytt lösenord',
  'resetPassword.newPasswordPlaceholder': 'Minst 6 tecken',
  'resetPassword.submit': 'Återställ lösenord',
  'resetPassword.success': 'Lösenordet har uppdaterats. Omdirigerar till inloggning...',
  'resetPassword.backToLogin': 'Tillbaka till inloggning',

  'account.delete.section_title': 'Radera konto',
  'account.delete.description': 'Om du raderar kontot tas alla dina data, meddelanden, kontakter och inställningar bort permanent. Åtgärden kan inte ångras.',
  'account.delete.button': 'Radera mitt konto',
  'accountDeletion.title': 'Radering av konto och data',
  'accountDeletion.description': 'Begär radering av ditt ArChat-konto och tillhörande data.',
  'accountDeletion.openRequest': 'Begär radering av konto och data',
  'account.delete.confirm_title': 'Radera konto',
  'account.delete.confirm_message': 'Är du säker på att du vill radera kontot? Ett bekräftelsemejl skickas till din inkorg. Raderingen är permanent och kan inte ångras.',
  'account.delete.email_sent_title': 'Mejl skickat',
  'account.delete.email_sent': 'Vi har skickat ett bekräftelsemejl. Kontrollera inkorgen och klicka på länken för att bekräfta raderingen.',
  'account.delete.error': 'Begäran kunde inte behandlas. Försök igen.',
  'account.delete.confirm_page_title': 'Bekräfta kontoradering',
  'account.delete.confirm_page_desc': 'Du håller på att permanent radera ditt ArChat-konto. Alla data, meddelanden, kontakter och inställningar tas bort. Åtgärden kan inte ångras.',
  'account.delete.confirm_final_button': 'Ja, radera mitt konto permanent',
  'account.delete.cancel_go_back': 'Avbryt och gå tillbaka',
  'account.delete.done_title': 'Kontot är raderat',
  'account.delete.done_message': 'Ditt konto har raderats. Alla data har tagits bort.',
  'account.delete_token_expired': 'Raderingslänken har löpt ut eller är ogiltig. Begär en ny från din profil.',
  'account.delete_token_invalid': 'Ogiltig eller saknad raderingslänk.',
  'account.delete_email_failed': 'Bekräftelsemejlet kunde inte skickas. Försök igen senare.',
  'account.delete_error': 'Fel vid radering. Försök igen senare.',

  'mail.send_failed': 'Återställningsmejl kunde inte skickas. Kontrollera SMTP-konfigurationen eller försök igen senare.',
  'auth.register_success_email_sent': 'Kontot skapades. Ett bekräftelsemejl har skickats. Kontrollera inkorgen (och skräppost) och klicka på länken för att aktivera kontot.',
  'auth.register_success_email_pending': 'Kontot skapades, men det uppstod ett problem vid skickande av bekräftelsemejlet. Aktiveringstoken är fortfarande giltig. Kontakta administratören eller begär ett nytt bekräftelsemejl.',
  'auth.email_not_verified': 'Du måste bekräfta din e-post för att aktivera kontot.',
  'auth.email_not_verified_title': 'Konto väntar på bekräftelse',
  'auth.email_send_failed': 'Vi kunde inte skicka mejlet. Försök igen eller ändra din e-post.',
  'auth.email_send_failed_title': 'Mejl kunde inte skickas',
  'auth.register.email_failed.title': 'Konto skapat',
  'auth.register.email_failed.message': 'Ditt konto skapades, men det uppstod ett problem vid skickande av bekräftelsemejlet. Kontrollera skräppost eller begär ett nytt mejl.',
  'auth.register.success.title': 'Konto skapat',
  'auth.register.success.message': 'Kontot skapades. Ett bekräftelsemejl har skickats. Kontrollera inkorgen (och skräppost) och klicka på länken för att aktivera kontot.',
  'auth.resend_sent': 'Bekräftelsemejl skickat igen.',
  'auth.resend_activation': 'Skicka aktiveringsmejl igen',
  'auth.resend_email': 'Skicka mejl igen',
  'auth.retry_resend': 'Försök igen',
  'auth.change_email': 'Ändra e-post',
  'auth.ver_email': 'Visa e-post',
  'auth.already_verified': 'Kontot är redan verifierat.',
  'auth.confirm_email_title': 'Bekräfta e-post',
  'auth.confirm_email_text': 'Aktiveringslänken skickas till:',
  'auth.confirm_email_edit': 'Redigera',
  'auth.confirm_email_confirm': 'Bekräfta',
  'auth.confirm_email_typo_hint': 'Menade du ***@{suggestion}?',
  'brand.slogan': 'Kraften i att bli förstådd, oavsett språk',
  "brand.appName": "ArChat®",
  "brand.name": "ArChat®",
  "home.title": "ArChat®",
  'home.slogan': 'Kraften i att bli förstådd, oavsett språk',
  'home.tagline': 'Meddelanden med automatisk översättning',
  'home.login': 'Logga in',
  'home.register': 'Skapa konto',
  'terms.title': 'Användarvillkor',
  'terms.accept': 'Godkänn och fortsätt',
  'terms.reject': 'Avvisa',
  'terms.rejectShort': 'Jag accepterar inte',
  'terms.readAndAccept': 'Jag har läst och accepterar användarvillkoren',
  'terms.cancel': 'Avbryt',
  'register.pageTitle': 'Skapa konto',
  'register.pageSubtitle': 'Ange dina uppgifter för att skapa kontot.',
  'register.submitLabel': 'Skapa konto',
  'register.confirm_title': 'Bekräfta konto',
  'register.confirm_message': 'Du är på väg att skapa kontot:',
  'register.confirm': 'Bekräfta',
  'register.creatingAccount': 'Skapar ditt konto…',
  'register.login_link': 'Har du redan ett konto?',
  'register.password_hint': 'Minst 6 tecken',
  'register.checking': 'Kontrollerar…',
  'register.username_taken': 'Detta användarnamn används redan.',
  'register.available': 'Tillgängligt',
  'register.emailAlreadyExists': 'Denna e-post är redan registrerad.',
  'register.continue': 'Fortsätt',
  'login.demo.title': 'Demoåtkomst',
  'login.demo.credentials': 'Användare: demo / Lösenord: demo',
  'login.email.placeholder': 'Ange din e-post för att bekräfta kontot',
  'login.email.help': 'En bekräftelselänk skickas till din e-post',
  'app.install': 'Installera ArChat',
  'app.install_ios_hint': 'För att installera: Dela > Lägg till på hemskärmen',
  'common.loading': 'Laddar…',
  'common.edit': 'Redigera',
  'common.on': 'På',
  'common.off': 'Av',
  'common.back': 'Tillbaka',
  'common.backToStart': 'Tillbaka till startsidan',
  'common.changeUser': 'Byt användare',
  'common.refresh': 'Uppdatera',
  'common.request_id_label': 'Begärande-ID',
  'login.email.invalid': 'Ange en giltig e-postadress',
  'system.processing': 'Bearbetar...',
  'captcha.solve': 'Lös CAPTCHA korrekt',
  'captcha.generateError': 'Fel vid generering av CAPTCHA. Ladda om sidan.',
  'captcha.label': 'Säkerhetsverifiering',
  'security.verification_title': 'Säkerhetsverifiering',
  'security.captcha_question': 'Verifieringsfråga',
  'security.enter_answer': 'Ange svaret',
  'captcha.description': 'Lös uträkningen för att fortsätta.',
  'captcha.required': 'Du måste ange CAPTCHA-svaret för att fortsätta.',
  'captcha.incorrect': 'CAPTCHA-svaret är felaktigt.',
  'captcha.placeholder': 'Ange svaret',
  'captcha.questionFormat': 'Vad är {a} + {b}?',
  'menu.conversations': 'Konversationer',
  'menu.admin': 'Förvaltning',
  'menu.promotions': 'Kampanjer',
  "navbar.profile": "Min profil",
  "navbar.settings": "Konfiguration",
  "navbar.logout": "Gå ut",
  'navbar.no_blocked_users': 'Inga blockerade användare',
  'navbar.blocked_users_title': 'Blockerade användare',
  'contacts.blocked_users_title': 'Blockerade användare',
  'contacts.country_label': 'Land',
  'contacts.not_reported': 'Ej angivet',
  "navbar.user_fallback": "Användare {id}",
  "navbar.open_guide": "Guide",
  "help.view_initial_guide": "Se den första guiden",
  "help.how_archat_works": "Hur ArChat® fungerar",
  "help.registration": "Spela in",
  "help.private_invitations": "Privata inbjudningar",
  "help.messaging": "Meddelanden",
  "help.security": "Säkerhet",
  "invitation.quick_button": "Bjud in kontakt",
  "onboarding.title": "Välkommen till ArChat®",
  "onboarding.subtitle": "Kommunicera med vem som helst på vilket språk som helst.",
  "onboarding.step1.label": "Steg 1",
  "onboarding.step1.text": "Bjud in din första kontakt",
  "onboarding.step2.label": "Steg 2",
  "onboarding.step2.text": "Skicka ditt första meddelande",
  "onboarding.actions.invite": "Bjud in kontakt",
  "onboarding.actions.explore": "Utforska ArChat®",
  "onboarding.welcome_title": "Välkommen till ArChat®",
  "onboarding.welcome_subtitle": "Kommunicera med vem som helst på vilket språk som helst.",
  "onboarding.step1": "Steg 1",
  "onboarding.step1_title": "Steg 1",
  "onboarding.step1_description": "Bjud in din första kontakt",
  "onboarding.step2": "Steg 2",
  "onboarding.step2_title": "Steg 2",
  "onboarding.step2_description": "Skicka ditt första meddelande",
  "onboarding.invite_contact": "Bjud in kontakt",
  "onboarding.explore_archat": "Utforska ArChat®",
  "referral.promo": "Bjud in och vinn 10 000 tecken",
  "referral.stats.sent": "Skickat",
  "referral.stats.accepted": "Accepterad",
  "referral.stats.rewards": "Belöningar",
  "referral.reward.pending": "Örhänge",
  "referral.reward.granted": "Fylld",
  "referral.reward.invalid": "Ogiltig",
  "referral.reward.in_progress": "I bruk",
  "referral.limit.reached": "Belöningsgräns nådd",
  "referral.waiting.usage": "+10 000 tecken vardera när du och din gäst skickar minst ett riktigt textmeddelande i samma chatt (servervaliderad).",
  "common.sending": "Sändning...",
  "menu.open": "Meny",
  "contacts.controls.hide_non_favorites": "Dölj icke-favoritkontakter",
  "contacts.controls.show_all": "Visa alla kontakter",
  "common.navigation": "Navigering",
  "common.favorite": "Favorit",
  "common.block": "Blockera",
  "common.user": "Användare",
  "common.avatar": "Avatar",
  "message.new": "nytt meddelande",
  "message.edit": "Redigera meddelande",
  "message.edit.save": "Spara redigering",
  "message.edit.cancel": "Avbryt redigering",
  'message.translating': 'Översätter...',
  'message.translation_failed': 'Kunde inte översätta',
  'message.not_translated': 'Originaltext',
  'message.retry_send': 'Försök igen',
  'message.retrying': 'Försöker igen...',
  "message.delete": "Ta bort meddelande",
  "message.deleted_placeholder": "Raderat meddelande",
  "message.edited": "Redigerat",
  "message.edited_at": "Redigerat den",
  'message.delete_for_me.tooltip': 'Ta bort för mig',
  'message.delete_for_me.aria': 'Ta bort det här meddelandet bara för mig',
  'message.delete_for_me.confirm_title': 'Ta bort meddelande',
  'message.delete_for_me.confirm_message': 'Det här meddelandet tas bara bort från din vy.',
  'message.delete_for_everyone.tooltip': 'Ta bort för alla',
  'message.delete_for_everyone.aria': 'Ta bort det här meddelandet för alla deltagare',
  'message.delete_for_everyone.confirm_title': 'Ta bort meddelande för alla',
  'message.delete_for_everyone.confirm_message': 'Det här meddelandet tas bort för dig och den andra deltagaren.',
  'message.delete_for_everyone.window_expired': 'Tidsfönster för borttagning har gått ut',
  "message.translation.show": "Se original och översättning",
  "message.translation.hide": "Dölj översättning",
  "emoji.search": "Sök emoji",
  "emoji.close": "Stäng väljaren",
  "captcha.refresh": "Återskapa CAPTCHA",
  "home.access_nav": "Tillgång till applikationen",
  "common.requiredFields": "Fyll i alla obligatoriska fält.",
  "bio.view": "Se biografi",
  "profile.founderBadge": "Grundare #{position}/{limit}",
  "profile.founderTooltip": "Grundande medlem – Priset fryst för livet så länge prenumerationen är aktiv",
  "profile.founderMember": "Grundare",
                'profile.founderHeaderBadge': '★ Grundare #{position}/150',
                'profile.camera.access_denied': 'Kunde inte komma åt kameran. Kontrollera behörigheter.',
  "profile.edit": "Redigera",
  "profile.save": "Spara ändringar",
  "profile.save.success": "Din profil har uppdaterats.",
  "profile.save.success.title": "Uppdaterad profil",
  "profile.update.success.title": "Uppdaterad profil",
  "profile.update.success.message": "Dina ändringar har sparats.",
  "profile.save.error": "Kunde inte uppdatera profilen. Försök igen.",
  "profile.save.error.title": "Spara fel",
  "profile.cancel": "Avboka",
  "profile.nick": "Användarnamn",
  "profile.nick.help": "Din unika identifierare i systemet",
  "profile.nick.readonly": "Användarnamn kan inte ändras",
  "profile.nick.readonly.help": "Användarnamnet är unikt och kan inte ändras",
  "profile.email.readonly": "E-postmeddelandet kan inte ändras",
  "profile.email.readonly.help": "E-postmeddelandet är unikt och kan inte ändras",
  "profile.name": "Riktigt namn",
  "profile.lastname": "Efternamn",
  "profile.alias": "Alias",
  "profile.email": "E-post",
  "profile.phone": "Telefon",
  "profile.country": "Land",
  "profile.country.select": "Välj land",
  "profile.biography": "Biografi",
  "bio.modal.original": "Original",
  'bio.modal.translation': 'Översättning',
  'bio.modal.empty': 'Den här kontakten har ingen biografi.',
  'bio.modal.translating': 'Översätter...',
  'bio.modal.translation_error': 'Biografin kunde inte översättas.',
  'attachment.unnamed_file': 'Fil',
  'auth.login_error.default_title': 'Åtkomstfel',
  'auth.login_error.default_message': 'Det gick inte att logga in.',
  "profile.photo": "Profilfoto",
                'notifications.bell.aria': 'Aviseringar',
                'notifications.panel.title': 'Aviseringar',
                'notifications.empty': 'Inga aviseringar',
                'notifications.mark_read': 'Markera som läst vid öppning',
  'profile.notifications.sound': 'Notification sound',
  "profile.notifications.sound_desc": "Spela upp ljud när viktiga meddelanden eller varningar kommer",
  "profile.invitations.title": "Inbjudningar",
  "profile.invitations.validated": "Validerade inbjudningar",
  "profile.invitations.nextBadge": "Nästa prestation",
  "profile.invitations.progress": "Framsteg",
  "profile.invitations.achievement": "Prestation",
  "profile.invitations.topInviterAchieved": "Maximalt antal inbjudna har uppnåtts",
  "profile.invitations.badges.networkBuilder": "Nätverksbyggare",
  "profile.invitations.badges.topInviter": "Maximalt antal inbjudare",
  "profile.invitations.achievement.networkBuilderMessage": "Du bjöd in 20 användare på ArChat.",
  "profile.invitations.achievement.topInviterMessage": "Du bjöd in 50 användare på ArChat.",
  "profile.plan.title": "Prenumerationsplan",
  "profile.plan.current": "Din nuvarande plan",
  "profile.plan.expires": "löper ut",
  "profile.plan.loading_info": "Laddar planinformation...",
  "profile.plan.valid_until": "Gäller till:",
  "profile.plan.active_since": "Aktiv sedan:",
  "profile.plan.active_badge": "✓ Aktiv",
  'profile.plan.free.description': 'Free plan with limitations. Upgrade to PRO for full access.',
  'profile.plan.pro.description': 'You have full access to all features.',
  "profile.plan.upgrade.button": "Uppgradera till PRO",
  'profile.plan.upgrade.hint': 'Access all features without limits',
  "profile.manage_plan": "Hantera plan",
  "plan.current_plan": "Nuvarande plan",
  "plan.current": "Actual",
  "plan.footer_prefix": "Plan:",
  "plan.upgrade_to_pro": "Uppgradera till PRO",
  "plan.upgrade_to_foundation": "Uppgradera till FOUNDATION",
  "plan.payment_coming": "Betalning med Paddle kommer snart att vara tillgänglig. Du kan ändra planer härifrån.",
  "plan.payment_coming_title": "Snart",
  "plan.foundation_full": "Stiftelsens kvot är full (150 grundare). Du kan välja PRO.",
  "plan.sold_out": "Utmattad",
  "plan.founder_spots_remaining": "Endast {count} platser tillgängliga",
  "plan.founders_occupied": "upptagna grundare",
  "plan.upgrade_not_allowed": "Endast användare med en GRATIS plan kan begära en uppgradering.",
  "plan.free_contacts": "Hasta 2 contactos",
  "plan.free_no_files": "Sin archivos",
  "plan.free_retention": "Historial 30 días",
  "plan.free_characters_month": "30,000 characters / month",
  "plan.pro_characters_month": "300,000 characters / month",
  "plan.pro_files": "Archivos hasta 50MB",
  "plan.pro_export": "Exportación",
  "plan.founder_support": "Prioridad soporte",
  "plan.founder_badge": "Badge fundador",
  "founder.title": "FOUNDATION (grundare)",
  "founder.subtitle": "Du stödjer projektet från början med ett livstidspris.",
  "founder.whatIs": "De första 150 användarna får FOUNDATION-planen till ett reducerat pris hela livet.",
  "founder.howItWorks": "Din Founder-nivå beror på din position (1 till 150).",
  "founder.benefitsTitle": "Fördelar",
  'founder.benefitPrice': '$15 / månad (Founder-pris)',
  "founder.benefitFeatures": "Inkluderar alla funktioner i PRO-planen.",
  "founder.limit": "Det finns bara 150 Founder-platser.",
  "founder.cancelRule": "Om du avbryter förlorar du Founder-status medan du avslutar prenumerationen.",
  "founder.rejoinRule": "Om det finns ledigt utrymme igen kan du återaktivera det och automatiskt bli en grundare igen.",
  "founder.tiers.title": "Grundare nivåer",
  "founder.tiers.legendary.name": "LEGENDARISK grundare",
  "founder.tiers.legendary.range": "Position 1–25",
  "founder.tiers.legendary.desc": "Den första att stödja projektet. Maximal historisk prioritet.",
  "founder.tiers.early.name": "TIDIGT grundare",
  "founder.tiers.early.range": "Position 26–75",
  "founder.tiers.early.desc": "Tidigt stöd med särskilt erkännande.",
  "founder.tiers.founder.name": "grundare",
  "founder.tiers.founder.range": "Position 76–150",
  "founder.tiers.founder.desc": "Grundarkvot inom 150 platser.",
  "founder.whatIsLink": "Vad är grundare?",
  "founder.viewTiers": "Se Founder-nivåer",
  'billing.change_plan': 'Byt plan',
  "billing.usage.title": "Planera användning",
  "billing.usage.users": "Användare",
  "billing.usage.messages": "Meddelanden (idag)",
  "billing.usage.invitations": "Inbjudningar (idag)",
  "billing.usage.messages_month": "Meddelanden denna månad",
  "billing.usage.chats": "Samtal",
  "billing.usage.contacts": "Kontakter",
  "billing.usage.chars_month": "Karaktärer per månad",
  "billing.usage.storage": "Använd förvaring",
  "billing.usage.devices": "Anslutna enheter",
  'billing.usage.warning': 'You are approaching your plan limit. Upgrade to PRO for more capacity.',
  'plans.limit.reached': 'Gräns uppnådd — Uppgradera plan',
  "billing.loading": "Laddar...",
  'billing.subscription.section_title': 'Prenumeration och fakturering',
  'billing.subscription.provider_note': 'Leverantör',
  'billing.subscription.paddle_active': 'Paddle (aktiv plan i appen)',
  'billing.subscription.mp_action_ok': 'Begäran registrerades. Om kassan inte öppnades, kontrollera anslutningen eller försök igen.',
  'billing.paddle.manage_subscription_button': 'Hantera prenumeration',
  'billing.paddle.portal_confirm_title': 'Faktureringsportal',
  'billing.paddle.portal_confirm': 'Den säkra Paddle-portalen öppnas för att uppdatera betalmetod, fakturor eller avsluta prenumerationen. Fortsätta?',
  'billing.paddle.portal_opened_hint': 'Paddle-portalen öppnades i en ny flik. Uppdatera profilen om planen inte ändrades.',
  'billing.paddle.portal_error': 'Kunde inte öppna Paddle-portalen. Försök senare eller kontakta support.',
  'billing.paddle.no_link_error': 'Ingen Paddle-prenumerationslänk på kontot ännu. Om du just betalade, vänta på webhook eller kontakta support.',
  'billing.paddle.api_not_configured': 'Servern saknar Paddle API-konfiguration (PADDLE_API_KEY). En administratör måste ange den.',
  "billing.descriptions.contacts": "Totalt antal kontakter lagrade på ditt konto",
  "billing.descriptions.storage": "Lagring som används för filer och media",
  "billing.descriptions.chars_month": "Karaktärer översatta denna månad",
  "billing.descriptions.devices": "Aktiva anslutna enheter",
  'billing.paddle.return_title': 'Betalning mottagen',
  'billing.paddle.return_body': 'Om du slutförde kassan uppdateras planen strax efter att Paddle bekräftar. Du kan gå tillbaka till startsidan.',
  'billing.paddle.verifying': 'Kontrollerar din plan…',
  'billing.paddle.not_logged_in': 'Logga in för att se uppdaterad planstatus.',
  'billing.paddle.plan_updated': 'Plan uppdaterad: {plan}',
  'billing.paddle.plan_current': 'Din nuvarande plan: {plan}',
  'billing.paddle.plan_current_founder': 'Du är nu Founder — {plan}',
  'billing.paddle.still_free_hint': 'Om du fortfarande ser FREE efter en stund kan webhooken vara försenad. Kontrollera backend-loggar eller uppdatera sidan.',
  'billing.paddle.pro_extra_hint': 'Du kan gå till startsidan för att använda din plan.',
  "profile.theme.dark": "Mörkt läge",
  "profile.theme.light": "Rensa läge",
  "profile.theme.argentina": "Argentina tema",
  "modal.title": "Kompetens",
  "modal.success.title": "Framgång",
  "modal.error.title": "Misstag",
  "modal.warning.title": "Varning",
  "info.title": "Information",
  "appearance.title": "Utseende",
  "appearance.theme.light": "Rensa",
  "appearance.theme.dark": "Mörk",
  "theme.title": "Utfärda",
  "theme.light": "Rensa",
  "theme.dark": "Mörk",
  "profile.photo.section": "Profilfoto",
  "profile.personalInfo": "Personlig information",
  "profile.preferences": "Inställningar",
  "profile.country.help": "Tidszonen tilldelas automatiskt baserat på det valda landet",
  "profile.lastname.placeholder": "Ditt efternamn (valfritt)",
  "profile.name.placeholder": "Ditt riktiga namn (valfritt)",
  "profile.biography.placeholder": "Berätta om dig själv...",
  "profile.photo.change": "Byt profilbild",
  "message.placeholder": "Skriv ett meddelande...",
  "message.placeholderWithFile": "Skicka fil",
  "message.sent_from_country": "Skickat från",
  "message.sent_at_local_time": "Emittentens lokala tid",
  "message.timezone_label": "tidszon",
  "message.context_info": "Detta meddelande bevarar tidskontexten för den tid det skickades.",
  "message.context_pro_hint": "Det här meddelandet har tid och geografisk kontext tillgängligt i Pro-planer.",
  "message.context_pro_badge": "Context Pro",
  "messages.empty": "Det finns inga meddelanden än",
  "messages.loading": "Läser in meddelanden...",
  "messages.connecting_server": "Ansluter till meddelandeservern...",
  "messages.pending_send_count": "{count} meddelande(n) väntar på leverans",
  "attachment.title": "Bifoga fil",
  "attachment.close": "Nära",
  "attachment.gallery": "Foto-/videogalleri",
  "attachment.cameraFront": "främre kameran",
  "attachment.cameraBack": "bakre kamera",
  "attachment.cameraWeb": "webbkamera",
  "attachment.selectFile": "Välj fil (PDF, text, bilder, videor)",
  "attachment.remove": "Eliminera",
  'attachments.recipientFreeBlocked.title': 'Plangräns',
  'attachments.recipientFreeBlocked.sender': 'Användaren har Free-plan och kan inte ta emot bilagor.',
  'attachments.recipientFreeBlocked.receiver': '{senderName} försökte skicka en bilaga, men ditt {planName}-abonnemang tillåter inte bilagor. Vi rekommenderar en högre plan för att ta emot filer.',
  'attachments.recipientFreeBlocked.upgradeCta': 'Uppgradera plan',
  "attachment.audioNotSupported": "Ljudmeddelanden stöds inte i ArChat®. Skicka ett skriftligt meddelande.",
  "message.audioDeprecated.title": "Röstmeddelande stöds inte",
  "message.audioDeprecated.message": "Detta röstmeddelande stöds inte längre av ArChat®. Skicka ett skriftligt meddelande.",
  "camera.title": "Kamera",
  "camera.close": "Nära",
  "camera.switch": "Byt kamera",
  "camera.capture": "Ta foto",
  "camera.loading": "Startar kamera...",
  "camera.retry": "Försöka igen",
  "camera.error.access": "Det gick inte att komma åt kameran. Kontrollera behörigheter.",
  "camera.error.permission": "Kamerabehörigheter nekades. Tillåt åtkomst till kameran i din webbläsarinställningar.",
  "camera.error.notFound": "Ingen tillgänglig kamera hittades.",
  "camera.error.busy": "Kameran används av ett annat program.",
  "camera.error.constraint": "Kamerabegränsningar kan inte uppfyllas.",
  "profile.photo.take": "Ta foto",
  "profile.photo.gallery": "Välj från galleri",
  "profile.photo.select": "Välj foto",
  "profile.photo.select.gallery": "Välj från galleri",
  "profile.photo.uploading": "Laddar upp bild...",
  "profile.photo.upload.success": "Profilfotot har uppdaterats",
  "profile.photo.upload.success.title": "Uppdaterat foto",
  "profile.photo.upload.error": "Det gick inte att ladda upp profilbilden. Försök igen.",
  "profile.photo.upload.error.title": "Fel vid uppladdning av foto",
  "avatar.errors.too_large": "Bilden är för stor. Maximal storlek: 2 MB.",
  "avatar.preview.title": "Avatar förhandsvisning",
  "profile.avatar.error_title": "Kunde inte uppdatera avatar",
  "profile.avatar.error.title": "Kunde inte uppdatera avatar",
  "profile.avatar.error.size": "Bilden överskrider den tillåtna storleken. Maximalt är 2 MB.",
  "profile.avatar.tooLarge.title": "Bilden är för stor",
  "profile.avatar.tooLarge.message": "Fotot överskrider den tillåtna storleken. Maximalt är 2 MB.",
  "profile.avatar.uploadError.title": "Kunde inte uppdatera avatar",
  "profile.avatar.uploadError.message": "Det gick inte att ladda upp bilden. Försök igen.",
  "profile.saveSuccess.title": "Uppdaterad profil",
  "profile.saveSuccess.message": "Dina ändringar har sparats.",
  "profile.avatar.file_too_large": "Bilden överskrider den maximala tillåtna storleken (2 MB).",
  "profile.avatar.file_too_large_hint": "Välj en ljusare bild eller minska storleken och försök igen.",
  "profile.photo.take.front": "främre kameran",
  "profile.photo.take.back": "bakre kamera",
  "profile.photo.take.webcam": "webbkamera",
  "profile.photo.camera.front": "främre kameran",
  "profile.photo.camera.back": "bakre kamera",
  "profile.photo.camera.web": "webbkamera",
  "profile.photo.close": "Nära",
  "profile.photo.capture": "Fånga",
  "user.default": "Användare",
  "logout.title": "Bekräfta",
  "logout.confirm": "Är du säker på att du vill logga ut?",
  "block.toggle_error": "Kunde inte låsa eller låsa upp.",
  "contacts.search.placeholder": "Sök på användarnamn, förnamn, efternamn, land eller språk...",
  "contacts.empty": "Det finns inga kontakter",
  "contacts.empty.title": "Du har fortfarande inga kontakter",
  "contacts.empty.message": "Bjud in eller skapa en för att komma igång.",
  "contacts.empty.invite_button": "Bjud in en kontakt",
  "contacts.empty.private.message": "Din profil är privat. Bjud in kontakter att börja chatta.",
  "contacts.empty.private.invite_button": "Bjud in en kontakt",
  "contacts.search.no_results": "Inga kontakter hittades",
  "contacts.search.clear": "Visa alla",
  "contacts.nick": "Användarnamn",
  "contacts.name": "Namn",
  "contacts.lastname": "Efternamn",
  "contacts.country": "Land",
  "contacts.language": "Språk",
  "contacts.status": "Ange",
  "contacts.status.pending_registration": "Registrering väntar",
  "contacts.status.registered": "Gäst - Registrerad",
  "contacts.status.ready_to_chat": "Redo att chatta",
  "contacts.status.active_conversation": "Aktiv konversation",
  "contacts.invitation.pending.title": "Väntande inbjudan",
  "contacts.invitation.pending.message": "Denna inbjudan väntar på registrering. Kontakten kommer att få ett e-postmeddelande för att slutföra sin registrering. När du har registrerat dig kommer du att kunna chatta med honom.",
  "contacts.error.no_registered": "Kontakten är ännu inte registrerad. Vänta tills din registrering är klar.",
  "contact.edit.title": "Redigera kontakt",
  "contact.edit.alias.label": "Anpassat alias",
  "contact.edit.alias.placeholder": "Ex: Juan från jobbet",
  "contact.edit.alias.help": "Detta namn kommer att visas istället för det riktiga namnet",
  "contact.edit.nota.label": "Personlig anteckning",
  "contact.edit.nota.placeholder": "Lägg till en anteckning om den här kontakten...",
  "contact.edit.nota.help": "Privata anteckningar är endast synliga för dig",
  "contact.edit.error.noUser": "Fel: Oidentifierad användare",
  "contact.edit.error.noContactId": "Fel: Kontakten kunde inte identifieras",
  "contact.edit.error.save": "Det gick inte att spara",
  "contact.limit.title": "Kontaktgräns nådd",
  "contact.limit.message": "Den GRATIS planen tillåter upp till 2 kontakter per användare. Du kan uppgradera till FOUNDATION eller PRO för mer kapacitet när laddning är aktiverad.",
  "contact.favorite.add": "Lägg till i favoriter",
  "contact.favorite.remove": "Ta bort från favoriter",
  "contact.block.block": "Blockera",
  'contact.block.unblock': 'Avblockera',
  "conversation.backToContacts": "Återgå till kontakter",
  "conversation.notFound": "Konversationen hittades inte",
  "help.howWorks.title": "👥 Hur ArChat® fungerar (riktigt flöde)",
  "help.howWorks.step1.title": "1️⃣ Anmälan",
  "help.howWorks.step1.point1": "Logga in med ditt smeknamn och lösenord.",
  "help.howWorks.step1.point2": "Om du inte har ett konto skapas det automatiskt.",
  "help.howWorks.step1.point3": "Du accepterar villkoren på ditt språk.",
  "help.howWorks.step1.point4": "Du bekräftar ditt konto via e-post.",
  "help.howWorks.step2.title": "2️⃣ Privata inbjudningar",
  "help.howWorks.step2.point1": "Bjud in kontakter via e-post från din profil.",
  "help.howWorks.step2.point2": "Definiera språk och konversationsläge innan du börjar.",
  "help.howWorks.step2.point3": "Kontakten får en privat inbjudan.",
  "help.howWorks.step2.point4": "Du kan se om det är: Väntande, Registrerad, Redo att chatta",
  "help.howWorks.step2.point5": "Kontakter söks inte, de är inbjudna.",
  "help.howWorks.step2.point6": "Kontakter söks inte, de är inbjudna.",
  "help.howWorks.step3.title": "3️⃣ Kontakter och konversationer",
  "help.howWorks.step3.point1": "Dina kontakter visas automatiskt när:",
  "help.howWorks.step3.point2": "acceptera en inbjudan",
  "help.howWorks.step3.point3": "eller det är en konversation",
  "help.howWorks.step3.point4": "Burk:",
  "help.howWorks.step3.point5": "markera dem som favoriter ⭐",
  "help.howWorks.step3.point6": "tilldela dem anpassade alias",
  "help.howWorks.step3.point7": "lägga till privata anteckningar",
  "help.howWorks.step3.point8": "blockera eller hantera dem",
  "help.howWorks.step3.point9": "Det finns ingen offentlig agenda eller synliga användare utan samtycke.",
  "help.howWorks.step4.title": "4️⃣ Meddelanden med översättning",
  "help.howWorks.step4.point1": "Skriv alltid på ditt språk.",
  "help.howWorks.step4.point2": "Systemet översätter meddelandet automatiskt.",
  "help.howWorks.step4.point3": "Mottagaren får den på sitt språk.",
  "help.howWorks.step4.point4": "Du kan se översättningen tillämpad.",
  "help.howWorks.step4.point5": "Om en översättning misslyckas, görs ett nytt försök automatiskt.",
  "help.howWorks.step4.point6": "ArChat® prioriterar tydlighet och mening, inte bara hastighet.",
  "help.privacy.title": "🔒 Sekretess och kontroll",
  "help.privacy.point1": "Din profil är privat som standard.",
  "help.privacy.point2": "Endast de du bjuder in kan se eller skriva till dig.",
  "help.privacy.point3": "Offentlig synlighet är valfritt och inaktiverat som standard.",
  "help.privacy.point4": "Aktiv säkerhet med:",
  "help.privacy.point5": "CAPTCHA",
  "help.privacy.point6": "satsbegränsande",
  "help.privacy.point7": "fingeravtryck",
  "help.privacy.point8": "e-postverifiering",
  "help.privacy.point9": "Dina konversationer är inte offentliga eller indexerade.",
  "help.files.title": "📎 Filer och export",
  "help.files.point1": "Bifoga bilder, videor och PDF-dokument.",
  "help.files.point2": "Ta bilder med främre kamera, bakre kamera eller webbkamera.",
  "help.files.point3": "Bilder komprimeras automatiskt.",
  "help.files.point4": "Förhandsgranska innan du skickar.",
  "help.files.point5": "Förloppsindikator under lastning.",
  "help.files.point6": "Exportera hela konversationer till:",
  "help.files.point7": "PDF",
  "help.files.point8": "Html",
  "help.files.point9": "Innehåller meddelanden, bilder och filer.",
  "help.files.point10": "Din data är din.",
  "help.experience.title": "🎨 Användarupplevelse",
  "help.experience.point1": "Närvarostatus och anpassade statuser med emoji.",
  "help.experience.point2": "Integrerade OpenMoji-emojis.",
  "help.experience.point3": "Läs och skriv indikatorer.",
  "help.experience.point4": "Optimerad mobilvy lika med desktop.",
  "help.experience.point5": "Installerbar PWA-applikation.",
  "help.experience.point6": "Två teman: Argentina (ljusblå/vit/guld) och Oscuro (djup lila).",
  "help.experience.point7": "Profilredigering utan läsk.",
  "help.experience.point8": "Landsväljare med automatisk tidszon.",
  "help.experience.point9": "Snabb åtkomst med favoriter, sökning och filter.",
  "help.languages.title": "🌍 Språk",
  "help.languages.point1": "Stöd för {count} språk.",
  "help.languages.point2": "Visuell väljare med flaggor.",
  "help.languages.point3": "Gränssnitt, T&C och mejl anpassade till valt språk.",
  "help.languages.point4": "Tvåvägs automatisk översättning mellan användare.",
  "help.tipsNew.title": "💡 Tips för att dra nytta av ArChat®",
  "help.tipsNew.point1": "Bjud bara in personer du verkligen vill kommunicera med.",
  "help.tipsNew.point2": "Använd alias och privata anteckningar för att organisera kontakter.",
  "help.tipsNew.point3": "Markera favoriter för snabb åtkomst.",
  "help.tipsNew.point4": "Kontrollera översättningen innan du skickar viktiga meddelanden.",
  "help.tipsNew.point5": "Exportera relevanta konversationer för backup eller arbete.",
  "help.tipsNew.point6": "Använd ArChat® när skriftlig tydlighet är nyckeln.",
  "help.whySubscribe.title": "🚀 Varför prenumerera på ArChat®",
  "help.whySubscribe.point1": "ArChat® är inte utformad för att chatta med vem som helst,",
  "help.whySubscribe.point2": "men att kommunicera bättre med dem som betyder något.",
  "help.whySubscribe.point3": "Om du behöver:",
  "help.whySubscribe.point4": "klarhet mellan språken",
  "help.whySubscribe.point5": "verklig integritet",
  "help.whySubscribe.point6": "kontaktkontroll",
  "help.whySubscribe.point7": "konversationsexport",
  "help.whySubscribe.point8": "en professionell och ljudfri upplevelse",
  "help.whySubscribe.point9": "ArChat® är designad för det.",
  "help.how.step1.description": "Använd ditt smeknamn och lösenord för att komma åt. Om du inte har ett konto skapas det automatiskt.",
  "help.how.step2.title": "Bjud in din kontakt",
  "help.how.step2.description": "Bjud in via e-post från din profil och definiera språket och konversationssättet.",
  "help.how.step3.title": "Skriv på ditt språk",
  "help.how.step3.description": "Skriv på ditt föredragna språk så översätter ArChat® automatiskt meddelandet.",
  "help.how.step4.title": "Mottagaren tar emot den översatt",
  "help.how.step4.description": "Den andra personen får meddelandet översatt till sitt språk med sammanhang och tydlighet.",
  "help.features.title": "Huvuddrag",
  "help.features.translation": "🌐 Automatisk och omedelbar översättning mellan språk",
  "help.features.status": "💬 Närvarolägen (online, inaktiv, Stör ej, etc.)",
  "help.features.statusCustom": "💬 Anpassade statusar med emoji och personligt meddelande",
  "help.features.contacts": "👥 Komplett lista över kontakter med fästade favoriter (överst) och block som kan hanteras från användarmodal",
  "help.features.contactsMobile": "📱 Optimerad mobilvy med status och utseende i toppfältet (samma som PC)",
  "help.features.contactsFilter": "👁️ Visa/dölj icke-favoritkontakter knapp - reducera listan till endast dina favoriter",
  "help.features.contactAlias": "✏️ Anpassat alias och privata anteckningar för varje kontakt - klicka på kontaktens namn i konversationen",
  "help.features.themes": "🎨 Två tillgängliga teman: Argentina (ljusblå/vit/guld) och Oscuro (djup lila)",
  "help.features.messages": "📨 Meddelanden i realtid med läsindikatorer, inbyggda OpenMoji-emojis och synlig skrivning",
  "help.features.attachments": "📎 Bifoga filer som är kompatibla med skriftlig kommunikation: bilder, videor och PDF-dokument",
  "help.features.camera": "📸 Ta bilder med framsidan, baksidan eller webbkameran",
  "help.features.gallery": "🖼️ Filval från galleriet",
  "help.features.compression": "🗜️ Automatisk bildkomprimering och generering av miniatyrbilder",
  "help.features.progress": "📊 Förloppsindikator under filuppladdning",
  "help.features.delete": "🗑️ Radering av egna meddelanden",
  "help.features.scroll": "⬇️ Rulla automatiskt till det sista meddelandet när du öppnar en konversation",
  "help.features.profile": "👤 Anpassningsbar profil med avatar, biografi och preferenser",
  "help.features.profileEdit": "✏️ Sömlös profilredigering (uppdateras inte under redigering)",
  "help.features.countries": "🌍 Komplett lista över 195+ länder med automatiskt val av tidszon",
  "help.features.registration": "📧 Registrering med obligatoriska villkor innan du skapar ett konto och e-postbekräftelse",
  "help.features.multilanguage": "🗣️ Stöd för {count} språk med flaggor; Villkor och e-postmeddelanden översatta till det valda språket",
  "help.features.pwa": "📲 PWA-applikation kan installeras på mobila enheter och skrivbord",
  "help.features.sync": "🔄 Automatisk meddelandesynkronisering var 5:e sekund",
  "help.features.deleteSync": "🗑️ Automatisk synkronisering av raderade meddelanden mellan enheter",
  "help.features.notifications": "🔔 Ljudaviseringar för nya mottagna meddelanden",
  "help.features.retranslation": "🔄 Automatisk omöversättning av meddelanden om det misslyckas första gången",
  "help.features.preview": "👁️ Förhandsgranska filer innan du skickar",
  "help.features.security": "🔒 Säkerhetssystem med CAPTCHA, fingeravtryck, hastighetsbegränsning och obligatoriskt T&C-flöde",
  "help.features.passwordRecovery": "🔑 Lösenordsåterställning via e-post",
  "help.features.emailConfirmation": "📧 Kontobekräftelse via e-post med aktiveringslänk",
  "help.features.invitations": "📧 Privata e-postinbjudningar - Bjud in externa kontakter med definierat språk och sammanhang",
  "help.features.invitationsManagement": "📋 Komplett inbjudningshantering - Lista, skicka om eller avbryt väntande inbjudningar från menyn",
  "help.features.contactStatus": "🏷️ Synliga kontaktstatusar - Se status för varje kontakt (väntande, registrerad, redo att chatta)",
  "help.features.favorites": "⭐ Favoritsystem - Markera kontakter som favoriter för snabb åtkomst till dem",
  "help.features.profilePhoto": "📸 Förbättrad profilfotouppladdning - Välj bilder från galleriet med omedelbar förhandsgranskning",
  "help.features.translationSender": "👁️ Se översättningar för avsändaren - Se hur ditt meddelande översattes till mottagarens språk",
  "help.features.unifiedContacts": "🔗 Enad kontaktmodell - Kontakter härrör från befintliga inbjudningar och konversationer",
  "help.features.privacy": "🔒 Privat läge som standard - Din profil är privat och endast tillgänglig via direkt inbjudan",
  "help.features.export": "💾 Konversationsexport - Exportera hela konversationer till PDF eller HTML med bilder och filer",
  "help.tips.title": "Användbara tips",
  "help.tips.language": "✅ Ställ in ditt språk med flaggväljaren {count}; Villkor och e-postmeddelanden visas på det språket",
  "help.tips.status": "✅ Uppdatera din närvarostatus så att andra vet din tillgänglighet",
  "help.tips.statusCustom": "✅ Skapa anpassade statusar med emoji och meddelande för att uttrycka din nuvarande status",
  "help.tips.search": "✅ Markera favoriter (stjärna) och blockera användare från modalen \"Användare\".",
  "help.tips.contactsFilter": "✅ Använd ögonknappen (👁️) i det översta fältet för att visa eller dölja icke-favoritkontakter",
  "help.tips.contactAlias": "✅ Klicka på kontaktens namn i konversationen för att lägga till ett anpassat alias och privata anteckningar",
  "help.tips.avatar": "✅ Klicka på en kontakts avatar för att se deras bild större",
  "help.tips.messages": "✅ ArChat®-ikonen blinkar när du har olästa meddelanden; infoga emojis med OpenMoji launcher",
  "help.tips.attachments": "✅ Bifoga bilder, videor eller PDF-filer med klippknappen (📎); förenlig med skriftlig kommunikation",
  "help.tips.camera": "✅ Använd kameran för att ta bilder direkt från appen",
  "help.tips.compression": "✅ Bilder komprimeras automatiskt för att spara utrymme",
  "help.tips.delete": "✅ Du kan ta bort dina egna meddelanden genom att klicka på ta bort-knappen",
  "help.tips.profile": "✅ Redigera din profil utan läsk och växla mellan Argentina/Mörkt (ljus eller mörkt tema).",
  "help.tips.themes": "✅ Ändra tema från Inställningar > Utseende: Argentina (ljusblå) eller mörk (djup lila)",
  "help.tips.country": "✅ Välj ditt land i profilen så att tidszonen ställs in automatiskt",
  "help.message_time_context.title": "Temporala sammanhang för meddelanden",
  "help.message_time_context.description": "Varje meddelande kan spara avsändarens lokala tid, tidszon och land vid tidpunkten för sändningen. På så sätt kan du se var och vid vilken tid den andra användaren skickade.",
  "help.message_time_context.point1": "I GRATIS-planen visas bara tiden i din tidszon (mottagare).",
  "help.message_time_context.point2": "I PRO-planen visas även emittentens lokala tid, land och tidszon.",
  "help.message_time_context.point3": "Kontexten sparas historiskt i varje meddelande.",
  "help.message_time_context.point4": "Avancerade granskningsfunktioner är tillgängliga på högre planer.",
  "help.tips.registration": "✅ Innan du registrerar dig, acceptera villkoren på ditt språk; verifiera sedan din e-post för att aktivera kontot",
  "help.tips.writing": "✅ Skriv tydliga budskap: ArChat® översätter innebörden av skriven text, upprätthåller sammanhang och tydlighet",
  "help.tips.install": "✅ Installera ArChat® som en PWA-app på din enhet för snabb åtkomst till skrivbordet",
  "help.tips.sync": "✅ Meddelanden synkroniseras automatiskt var 5:e sekund - du behöver inte uppdatera",
  "help.tips.deleteSync": "✅ Om du tar bort ett meddelande raderas det automatiskt på alla mottagarens enheter",
  "help.tips.notifications": "✅ Du kommer att höra ett ljud när du får ett nytt meddelande från en annan användare",
  "help.tips.retranslation": "✅ Om ett meddelande inte översatts korrekt kommer systemet att försöka översätta det automatiskt",
  "help.tips.preview": "✅ Kontrollera förhandsgranskningen av filen innan du skickar för att se till att det är rätt",
  "help.tips.passwordRecovery": "✅ Om du har glömt ditt lösenord, använd länken \"Glömt ditt lösenord?\" i inloggningen",
  "help.tips.emailConfirmation": "✅ Kontrollera din e-post efter registrering och klicka på bekräftelselänken",
  "help.tips.languageChange": "✅ Ändra ditt språk från flaggväljaren: Villkor, e-postmeddelanden och användargränssnitt uppdateras omedelbart",
  "help.tips.inputFixed": "✅ På PC är skrivfältet fixerat längst ner på skärmen för större komfort",
  "help.tips.invitations": "✅ Bjud in kontakter via e-post från din profil - Definiera språket och konversationsläget från början",
  "help.tips.invitationsManagement": "✅ Hantera dina inbjudningar från menyn \"Skickade inbjudningar\" - Skicka e-post igen eller avbryt väntande inbjudningar",
  "help.tips.contactStatus": "✅ Se status för varje kontakt i listan - Väntande (orange), Registrerad (grön) eller Aktiv konversation (blå)",
  "help.tips.favorites": "✅ Markera kontakter som favoriter med stjärnan ⭐ - Favoriter visas först i din lista",
  "help.tips.profilePhoto": "✅ Ladda upp din profilbild från \"Välj från galleri\" - Du kommer att se en förhandsgranskning innan du sparar",
  "help.tips.translationSender": "✅ När du skickar ett meddelande, expandera översättningspanelen för att se hur det översattes till mottagarens språk",
  "help.tips.unifiedContacts": "✅ Dina kontakter visas automatiskt när de accepterar inbjudningar eller har konversationer med dem",
  "help.tips.privacy": "✅ Din profil är privat som standard - Aktivera offentlig synlighet i Profil > Sekretess om du vill att andra ska hitta dig",
  "help.tips.export": "✅ Exportera hela konversationer med knappen ⬇️ i rubriken - Välj PDF eller HTML med alla bilder",
  "help.support.title": "Medium",
  "help.support.description": "Om du har problem eller frågor, kontakta din systemadministratör eller läs den tillgängliga tekniska dokumentationen.",
  "help.about.title": "Om",
  "help.about.developer": "Utvecklad av:",
  "help.about.location": "MDQ - ARGENTINA",
  "help.about.linkedin": "Se profil på LinkedIn",
  "presence.custom.suggestion.coffee": "Att ha några kompisar ☕",
  "presence.custom.suggestion.soccer": "På banan ⚽",
  "presence.custom.suggestion.working": "Jobbar som en galning 💪",
  "presence.custom.suggestion.lunch": "Äter lunch 🍽️",
  "presence.custom.suggestion.family": "Familjelunch 👨‍👩‍👧‍👦",
  "presence.custom.suggestion.studying": "Studerar 📚",
  "presence.custom.suggestion.travel": "På resa ✈️",
  "presence.custom.suggestion.meeting": "I möte 💼",
  "presence.custom.suggestion.resting": "Vilar 😴",
  "presence.custom.suggestion.gaming": "Spelar tv-spel 🎮",
  "presence.custom.suggestion.reading": "Läser 📖",
  "presence.custom.suggestion.offlineSoon": "Jag kommer genast tillbaka ⏳",
  "export.title": "Exportera konversation",
  "export.description": "Välj det format som du vill exportera den här konversationen i:",
  "export.progress": "Exporterar...",
  "export.format.pdf": "PDF",
  "export.format.pdf.description": "PDF-dokument med alla bilder och filer",
  "export.format.html": "Html",
  "export.format.html.description": "HTML-fil som du kan öppna i vilken webbläsare som helst",
  "export.info": "Exporten kommer att inkludera alla meddelanden, bilder och filer från denna konversation.",
  "export.pro_required.title": "Exportera konversation",
  "export.pro_required.message": "Den här funktionen är tillgänglig i PRO-planen.",
  "invitation.email.placeholder": "ejemplo@email.com",
  "invitation.success.message": "Inbjudan har skickats.\\n\\nKontakten kommer att få ett e-postmeddelande med en länk för att acceptera inbjudan. När du har accepterat kan du börja chatta med honom.",
  "invitation.error.self": "Du kan inte bjuda in dig själv",
  "invitation.error.duplicate": "Det finns redan en väntande inbjudan för detta e-postmeddelande",
  "invitation.top.title": "Topp nätverksbyggare",
  "invitation.top.invitesSuffix": "inbjudningar",
  "invitation.safe.phase_notice": "Aktiv säker fas: fördelar i väntan på kommersiell aktivering (ingen verklig påverkan på gränser).",
  "invitation.safe.generate_code": "Skapa länk/kod",
  "invitation.safe.refresh_top3": "Uppdatera topp 3",
  "invitation.safe.top_loading": "Läser in de bästa inbjudarna...",
  "invitation.safe.top_empty": "Det finns inga utvalda inbjudna än.",
  "invitation.safe.hide_full_ranking": "Dölj hela rankningen",
  "invitation.safe.view_full_ranking": "Se hela rankingen",
  "invitation.safe.hide_metrics_dashboard": "Dölj instrumentpanelen för mätvärden",
  "invitation.safe.view_metrics_dashboard": "Visa instrumentpanelen för mätvärden",
  "invitation.safe.prepared_link": "Länk förberedd",
  "invitation.safe.email_placeholder": "email@dominio.com",
  "invitation.safe.register_pending": "Registrera väntande inbjudan",
  "invitation.safe.status_summary": "Statussammanfattning",
  "invitation.safe.summary.pending": "Örhängen",
  "invitation.safe.summary.registered": "Registrerad",
  "invitation.safe.summary.active": "Aktiv",
  "invitation.safe.summary.validated": "Validerad",
  "invitation.safe.summary.rejected": "Avvisad",
  "invitation.safe.sent_invitations": "Inbjudningar utfärdade",
  "invitation.safe.table.id": "ID",
  "invitation.safe.table.invited_email": "Gästmail",
  "invitation.safe.table.code": "Koda",
  "invitation.safe.table.status": "Ange",
  "invitation.safe.table.created": "Skapad",
  "invitation.safe.empty_sent": "Inga inbjudningar har utfärdats ännu.",
  "invitation.safe.simulated_rewards": "Simulerade belöningar intjänade",
  "invitation.safe.empty_rewards": "Inga simulerade belöningar för tillfället.",
  "invitation.safe.error.load_status": "Det gick inte att läsa in inbjudningsstatus.",
  "invitation.safe.error.generate_code": "Koden kunde inte genereras.",
  "invitation.safe.error.invalid_email": "Ange en giltig e-postadress för att registrera inbjudan.",
  "invitation.safe.error.register_pending": "Den väntande inbjudan kunde inte registreras.",
  "invitation.safe.success.code_generated": "Framgångsrikt genererad kod.",
  "invitation.safe.success.pending_registered": "Väntande inbjudan registrerad i felsäkert läge.",
  "invitation.ranking.position": "Placera",
  "invitation.ranking.user": "Användare",
  "invitation.ranking.validatedInvites": "Validerade inbjudningar",
  "invitation.ranking.empty": "Det finns inga validerade inbjudningar att visa.",
  "invitation.ranking.loading": "Laddar ranking...",
  "invitation.ranking.loadError": "Rankingen kunde inte laddas.",
  "invitation.status.deleted": "Utslagen",
  "invitation.deleted.tooltip": "Den här inbjudan togs bort",
  "invitation.status.rejected": "Avvisad",
  "invitation.status.bounced": "Studsade",
  "invitation.status.unknown": "Okänd status",
  "invitation.copy.link": "Kopiera länk",
  "invitation.copy.success": "Länken har kopierats till urklipp",
  "invitation.accept.title": "Acceptera inbjudan",
  "invitation.accept.description": "Du har blivit inbjuden att chatta på ArChat®",
  "invitation.accept.inviter": "Inbjuden av",
  "invitation.accept.message": "personligt meddelande",
  "invitation.accept.login": "Inloggning",
  "invitation.accept.register": "Register",
  "invitation.accept.error.invalid": "Ogiltig inbjudanstoken",
  "invitation.accept.error.expired": "Denna inbjudan har upphört att gälla",
  "invitation.accept.error.accepted": "Denna inbjudan har redan accepterats",
  "invitation.accept.error.cancelled": "Denna inbjudan avbröts",
  "invitation.accept.error.email_mismatch": "Ditt kontos e-postadress matchar inte inbjudan",
  "invitation.accept.success": "Inbjudan accepterad. Omdirigerar till chatt...",
  "invitations.sent.empty": "Det finns inga väntande inbjudningar",
  "invitations.columns.email": "E-post",
  "invitations.columns.language": "Språk",
  "invitations.columns.mode": "Läge",
  "invitations.columns.status": "Ange",
  "invitations.columns.sentAt": "Skickat",
  "invitations.columns.actions": "Åtgärder",
  "invitations.status.pending": "Örhänge",
  "invitations.status.accepted": "Accepterad",
  "invitations.status.cancelled": "Avbruten",
  "invitations.status.expired": "Utgått",
  "invitations.actions.cancel": "Avboka",
  "invitations.actions.copy": "Kopiera länk",
  "invitations.actions.resend": "Vidarebefordra e-post",
  "invitations.waitBeforeResend": "Du kan inte skicka om inbjudan ännu. Du måste vänta 10 minuter mellan varje sändning för att undvika att spamma gästanvändaren.",
  "invitations.captchaQuestion": "Hur mycket är %1 + %2?",
  "invitations.resendSuccess": "Inbjudan vidarebefordrades framgångsrikt.",
  "invitations.dailyLimit": "Du har nått det högsta tillåtna antalet återinlämningar idag.",
  "invitations.invalidEmail": "E-postservern rapporterade att den här adressen är ogiltig.",
  "profile.privacy.title": "Privatliv",
  "profile.privacy.public_visibility": "Gör min profil offentligt synlig",
  "profile.privacy.public_warning": "Detta gör att alla ArChat®-användare kan hitta dig och starta en konversation.",
  "profile.privacy.private_info": "Din profil är privat. Endast användare som du bjuder in eller som bjuder in dig kommer att kunna chatta med dig.",
  "profile.privacy.private_default": "Som standard är din profil privat för ökad säkerhet.",
  "common.confirm": "Bekräfta",
  "common.save": "Hålla",
  "common.saving": "Sparande...",
  'buttons.accept': 'Godkänn',
  "buttons.cancel": "Avboka",
  "buttons.save": "Hålla",
  "buttons.edit": "Redigera",
  "buttons.retry": "Försöka igen",
  "buttons.confirm": "Bekräfta",
  "buttons.yes": "Ja",
  "buttons.no": "Inga",
  "buttons.send": "Skicka",
  "buttons.close": "Nära",
  "buttons.continue": "Fortsätta",
  "buttons.delete": "Eliminera",
  "buttons.logout": "Gå ut",
  "buttons.back": "Återvända",
  "buttons.update": "Uppdatera",
  "buttons.upload": "Öka",
  "buttons.select": "Välja",
  "achievement.unlocked": "Prestation låst upp",
  "achievement.continue": "Fortsätta",
  "contact.edit.info.personalized": "Dessa ändringar är anpassade enbart för dig och påverkar inte andra användare.",
  "contact.edit.profileInfo": "Profilinformation",
  "dashboard.loading": "Laddar data...",
  "dashboard.error.title": "Misstag",
  "dashboard.error.load": "Användningsdata kunde inte laddas",
  "dashboard.error.generic": "Det gick inte att läsa in instrumentpanelen",
  "dashboard.error.no_data": "Data kunde inte laddas",
  "dashboard.retry": "Försöka igen",
  "dashboard.unlimited": "Obegränsat",
  'dashboard.not_available': 'Inte tillgänglig',
  "dashboard.plan.free": "FREE",
  "dashboard.plan.pro": "PRO",
  "dashboard.plan.enterprise": "ENTERPRISE",
  "dashboard.card.chars": "Karaktärer",
  "dashboard.card.chars_month": "Karaktärer denna månad",
  "dashboard.card.storage": "Lagring",
  "dashboard.card.devices": "Aktiva enheter",
  "dashboard.admin.title": "Tillväxtmått",
  "dashboard.admin.newUsersToday": "Nya användare idag",
  "dashboard.admin.messagesSentToday": "Meddelanden skickade idag",
  "dashboard.admin.translationsUsed": "Använda översättningar",
  "dashboard.admin.invitesCreated": "Inbjudningar skapade",
  "dashboard.admin.invitesValidated": "Validerade inbjudningar",
  "dashboard.admin.inviteConversion": "Konvertering av inbjudan",
  "dashboard.admin.kFactor": "K-faktor",
  "dashboard.admin.newUsers": "Nya användare",
  "dashboard.admin.messagesSent": "Skickade meddelanden",
  "dashboard.admin.noData": "Inga data",
  "dashboard.admin.kFactor.viral": "Viral",
  "dashboard.admin.kFactor.stable": "Stabil",
  "dashboard.admin.kFactor.low": "Låg",
  "dashboard.admin.emailMetrics": "E-poststatistik",
  "dashboard.admin.email.sent": "Skickat",
  "dashboard.admin.email.delivered": "Levereras",
  "dashboard.admin.email.opened": "öppna",
  "dashboard.admin.email.clicked": "Klick",
  "dashboard.admin.email.bounced": "Studsade",
  "dashboard.admin.email.deliveryRate": "Leveranshastighet",
  "dashboard.admin.email.openRate": "Öppen kurs",
  "dashboard.admin.email.bounceRate": "avvisningsfrekvens",
  "dashboard.admin.funnelMetrics": "Trattstatistik",
  "dashboard.admin.funnel.registered": "Registrerad",
  "dashboard.admin.funnel.confirmed": "Bekräftad",
  "dashboard.admin.funnel.loggedIn": "Första inloggningen",
  "dashboard.admin.funnel.firstMessage": "Första meddelandet",
  "dashboard.admin.funnel.abandoned": "Övergiven",
  "dashboard.admin.funnel.conversionRate": "Omvandlingsfrekvens",
  "dashboard.admin.funnel.activationRate": "Aktiveringshastighet",
  "dashboard.admin.funnel.dropoffRate": "Avhoppsfrekvens",
  "dashboard.admin.loading": "Läser in mätvärden...",
  "dashboard.admin.errorLoad": "Mätvärdesöversikten kunde inte läsas in.",
  "dashboard.admin.growthViral": "Viral tillväxt",
  "dashboard.admin.growthStable": "Stabil tillväxt",
  "dashboard.admin.growthLow": "Låg tillväxt",
  "dashboard.upgrade.title": "Behöver du mer resurser?",
  'dashboard.upgrade.message': 'Upgrade your plan to get more contacts, characters, storage and active devices.',
  "dashboard.upgrade.button": "Förbättra planen",
  "upgrade.title": "Förbättra planen",
  "upgrade.close": "Nära",
  "upgrade.cancel": "Avboka",
  "upgrade.activate": "Aktivera PRO-plan",
  "upgrade.activating": "Aktiverar...",
  'upgrade.price.amount': '',
  'upgrade.price.period': '',
  'upgrade.price.note': '',
  "upgrade.comparison.title": "Planjämförelse",
  "upgrade.free.label": "Gratis plan",
  "upgrade.free.limits.contacts": "Max 2 kontakter",
  "upgrade.free.limits.conversations": "Max 2 samtal",
  "upgrade.free.limits.no_export": "Ingen dataexport",
  "upgrade.free.limits.no_advanced": "Inga avancerade funktioner",
  "upgrade.pro.label": "Pro Plan",
  "upgrade.pro.recommended": "REKOMMENDERAD",
  'upgrade.pro.benefits.contacts': 'Unlimited contacts',
  'upgrade.pro.benefits.contacts.desc': 'Add all the contacts you need without restrictions',
  'upgrade.pro.benefits.conversations': 'Unlimited conversations',
  'upgrade.pro.benefits.conversations.desc': 'Keep all active conversations you need',
  "upgrade.pro.benefits.export": "Konversationsexport",
  "upgrade.pro.benefits.export.desc": "Exportera dina konversationer i flera format (PDF, TXT, JSON)",
  "upgrade.pro.benefits.notifications": "Avancerade aviseringar",
  "upgrade.pro.benefits.notifications.desc": "Anpassade aviseringar och avancerade inställningar",
  'upgrade.pro.benefits.translation': 'Unlimited automatic translation',
  'upgrade.pro.benefits.translation.desc': 'Translate messages without usage limits',
  'upgrade.pro.benefits.files': 'Unlimited file sharing',
  'upgrade.pro.benefits.files.desc': 'Share files of any size without restrictions',
  "upgrade.pro.benefits.themes": "Anpassade teman",
  "upgrade.pro.benefits.themes.desc": "Tillgång till alla teman och avancerad anpassning",
  "upgrade.pro.benefits.security": "Avancerad säkerhet",
  "upgrade.pro.benefits.security.desc": "Ytterligare skydd och förbättrade integritetsfunktioner",
  "upgrade.pro.benefits.analytics": "Statistik och analys",
  "upgrade.pro.benefits.analytics.desc": "Få tillgång till detaljerad statistik över din aktivitet",
  "upgrade.pro.benefits.priority": "Prioriterat stöd",
  "upgrade.pro.benefits.priority.desc": "Prioriterad uppmärksamhet och snabbt svar på dina frågor",
  "upgrade.enterprise.label": "Företagsplan",
  "upgrade.enterprise.title": "ENTERPRISE",
  "upgrade.enterprise.benefits.contacts": "Obegränsade kontakter",
  "upgrade.enterprise.benefits.support": "24/7 prioriterad support",
  "upgrade.enterprise.benefits.custom": "Skräddarsydda lösningar",
  "upgrade.enterprise.benefits.advanced": "Avancerade affärsfunktioner",
  "upgrade.enterprise.benefits.integration": "Anpassade integrationer",
  "upgrade.enterprise.benefits.dedicated": "Dedikerad support",
  "upgrade.success.title": "PRO Plan aktiverad",
  "upgrade.success.message": "Din plan har uppgraderats till PRO. Njut av alla obegränsade funktioner.",
  "upgrade.error.title": "Fel vid aktivering av PRO",
  "upgrade.error.message": "Planen kunde inte uppdateras. Försök igen.",
  "upgrade.error.generic": "Ett oväntat fel inträffade. Försök igen.",
  'upgrade.benefits.contacts': 'Unlimited contacts',
  'upgrade.benefits.contacts.desc': 'Add all the contacts you need without restrictions',
  'upgrade.benefits.conversations': 'Unlimited conversations',
  'upgrade.benefits.conversations.desc': 'Keep all active conversations you need',
  "upgrade.benefits.export": "Konversationsexport",
  "upgrade.benefits.export.desc": "Exportera dina konversationer i flera format (PDF, TXT, JSON)",
  "upgrade.benefits.notifications": "Avancerade aviseringar",
  "upgrade.benefits.notifications.desc": "Anpassade aviseringar och avancerade inställningar",
  'upgrade.benefits.translation': 'Unlimited automatic translation',
  'upgrade.benefits.translation.desc': 'Translate messages without usage limits',
  'upgrade.benefits.files': 'Unlimited file sharing',
  'upgrade.benefits.files.desc': 'Share files of any size without restrictions',
  "upgrade.benefits.themes": "Anpassade teman",
  "upgrade.benefits.themes.desc": "Tillgång till alla teman och avancerad anpassning",
  "upgrade.benefits.security": "Avancerad säkerhet",
  "upgrade.benefits.security.desc": "Ytterligare skydd och förbättrade integritetsfunktioner",
  "upgrade.benefits.analytics": "Statistik och analys",
  "upgrade.benefits.analytics.desc": "Få tillgång till detaljerad statistik över din aktivitet",
  "upgrade.benefits.priority": "Prioriterat stöd",
  "upgrade.benefits.priority.desc": "Prioriterad uppmärksamhet och snabbt svar på dina frågor",
  "upgrade.limits.contacts": "Max 2 kontakter",
  "upgrade.limits.conversations": "Max 2 samtal",
  "upgrade.limits.no_export": "Ingen dataexport",
  "upgrade.limits.no_advanced": "Inga avancerade funktioner",
  "api.error.image_processing_not_available": "Bildbehandling är inte tillgänglig på servern",
  "api.error.image_functions_not_available": "Bildbehandlingsfunktioner är inte tillgängliga",
  "api.error.method_not_allowed": "Ej tillåten metod",
  "api.error.user_not_identified": "Oidentifierad användare",
  "api.error.upload_file_too_large_php": "Filen överskrider den maximala storleken som tillåts av PHP",
  "api.error.upload_file_too_large_form": "Filen överskrider den maximala storleken som formuläret tillåter",
  "api.error.upload_file_partial": "Filen laddades delvis upp",
  "api.error.upload_no_file": "Ingen fil laddad upp",
  "api.error.upload_no_temp_dir": "Tillfällig katalog saknas",
  "api.error.upload_cant_write": "Fel vid skrivning av fil till disk",
  "api.error.upload_extension_stopped": "Ett PHP-tillägg slutade laddas upp",
  "api.error.upload_generic": "Filuppladdningsfel",
  "api.error.file_type_not_allowed": "Filtyp är inte tillåten. Endast bilder (JPEG, PNG, GIF, WEBP) är tillåtna",
  "api.error.file_too_large": "Filen är för stor (max 10 MB)",
  "api.error.storage_limit_exceeded": "Lagringsgränsen har överskridits. Uppgradera din plan för att ladda upp fler filer.",
  "api.error.user_not_found": "Användaren hittades inte eller inaktiv",
  "api.error.image_directory_access": "Det gick inte att komma åt bildkatalogen",
  "api.error.file_extension_not_allowed": "Filtillägg är inte tillåtet",
  "api.error.temp_file_save": "Det gick inte att spara temporär fil",
  "api.error.image_processing": "Det gick inte att bearbeta bilden",
  "api.error.database_update": "Fel vid uppdatering av databasen",
  "api.error.internal_server_error": "Internt serverfel",
  "api.error.internal_server_error_debug": "Internt serverfel",
  "api.error.user_id_required": "Obligatoriskt användar-ID",
  "api.error.profile_not_found": "Profilen hittades inte",
  "api.error.profile_load_failed": "Det gick inte att läsa in profilen",
  "api.error.invalid_data": "Ogiltig data",
  "api.error.validation_errors": "Valideringsfel",
  "api.error.profile_update_failed": "Kunde inte uppdatera profilen",
  "api.error.profile_update_error": "Fel vid uppdatering av profil",
  "api.success.photo_updated": "Uppdaterat foto",
  "api.success.profile_loaded": "Profilen har lästs in",
  "api.success.profile_updated": "Profilen har uppdaterats",
  "errors.deviceLimit.title": "Enhetsgränsen nådd",
  "errors.deviceLimit.solution": "Logga ut från andra enheter eller uppgradera din plan för att fortsätta.",
  "errors.network.title": "Anslutningsfel",
  "errors.network.message": "Kunde inte ansluta till servern. Kontrollera din internetanslutning.",
  "errors.server.invalidResponse.title": "Serverfel",
  "errors.server.invalidResponse.message": "Servern returnerade ett ogiltigt svar. Försök igen.",
  "errors.generic": "Ett oväntat fel inträffade. Försök igen.",
  "errors.modal.title": "Misstag",
  "errors.modal.copyDetails": "Kopiera detalj",
  "errors.modal.close": "Nära",
  "errors.modal.reportSupport": "Anmäl till support",
  "errors.modal.code": "Koda",
  "errors.modal.message": "Meddelande",
  "errors.modal.path": "Rutt",
  "errors.modal.time": "Timme",
  "errors.modal.timestamp": "Tidsstämpel",
  "errors.modal.copied": "Kopierad detalj",
  "errors.generic.title": "Misstag",
  "errors.generic.message": "Ett fel uppstod. Försök igen.",
  "errors.network": "Kunde inte ansluta till servern. Kontrollera din anslutning.",
  "errors.unexpected": "Ett oväntat fel inträffade. Försök igen.",
  "errors.boundary.title": "REAKERA FEL FÅNGAT",
  "errors.boundary.request_id": "X-Request-ID:",
  "errors.boundary.correlate": "Karta till backend/logs/structured.log",
  "errors.boundary.message_label": "Meddelande:",
  "errors.boundary.stack_trace": "Stack spår",
  "errors.boundary.component_stack": "komponentstapel",
  "errors.boundary.empty": "(tömma)",
  "errors.boundary.reload_page": "Ladda om sidan",
  "errors.ui_boundary.refresh": "ArChat-gränssnittsfel — ladda om sidan",
  "bootstrap.error.title": "ArChat® — Startfel",
  "common.reload": "Ladda om",
  "errors.avatarTooLarge": "Bilden överskrider den tillåtna storleken på 2 MB.",
  "errors.avatarTooLarge.title": "Bilden är för stor",
  "errors.avatarTooLarge.message": "Bilden överskrider den tillåtna storleken på 2 MB.",
  "errors.invalidImageType": "Den valda filen är inte en giltig bild.",
  "errors.invalidImageType.title": "Ogiltig fil",
  "errors.invalidImageType.message": "Den valda filen är inte en giltig bild.",
  "errors.uploadFailed": "Kunde inte ladda upp bilden. Försök igen.",
  "errors.uploadFailed.title": "Fel vid uppladdning",
  "errors.uploadFailed.message": "Kunde inte ladda upp bilden. Försök igen.",
  "errors.conversationCreate": "Det gick inte att skapa konversation. Försök igen.",
  "errors.conversationInvalidId": "Ogiltigt konversations-ID.",
  "errors.conversationOpen": "Det gick inte att öppna konversationen. Försök igen.",
  "errors.favoriteUpdate": "Det gick inte att uppdatera favoriten",
  "errors.blockUpdate": "Det gick inte att uppdatera låset",
  "errors.messageEdit": "Fel vid redigering av meddelande.",
  "errors.generic.403.title": "Åtkomstfel",
  "errors.generic.403.message": "Du har inte behörighet att utföra den här åtgärden.",
  "errors.saas_max_users": "Planens användargräns ({current}/{limit}) har nåtts.",
  "errors.tenant_frozen": "Hyresgästen är tillfälligt spärrad.",
  "errors.auth_invalid_credentials": "Felaktigt användarnamn eller lösenord.",
  "errors.foundation_sold_out": "Grundarplatserna är slutsålda.",
  "errors.unexpected_error": "Ett oväntat fel inträffade. Försök igen.",
  "errors.accountInactive.title": "Kontot är inaktivt. Fyll i din e-post för att återaktivera den.",
  "errors.userInactive.title": "Inaktiverat konto",
  "errors.tenantMismatch.title": "Hyresgäst fel",
  "errors.accountInactive.activate": "Aktivera nu",
  "errors.accountInactive.accept": "Acceptera",
  "errors.accountInactive.success": "Kontot har återaktiverats. Du kan nu logga in.",
  "errors.accountInactive.fail": "Kunde inte återaktivera kontot. Försök igen.",
  "errors.accountInactive.completeSuccess": "Kontot aktiverat med din e-post. Du kan nu logga in.",
  "errors.accountInactive.completeFail": "Aktiveringen kunde inte slutföras. Kontrollera e-postmeddelandet och försök igen.",
  "plan.errors.deviceLimit.title": "Plangränsen nådd",
  "plan.errors.deviceLimit.message": "Din nuvarande plan har en gräns för antalet samtidigt anslutna enheter.",
  "plan.errors.deviceLimit.solution": "För att fortsätta logga ut från andra enheter eller uppgradera din plan till PRO.",
  "plan.errors.contactsLimit.title": "Kontaktgräns nådd",
  "plan.errors.contactsLimit.message": "Din nuvarande plan har en gräns för antalet kontakter du kan ha.",
  "plan.errors.contactsLimit.solution": "För att lägga till fler kontakter, uppgradera din plan till PRO.",
  "plan.errors.invitationsLimit.title": "Gränsen för inbjudningar har nåtts",
  "plan.errors.invitationsLimit.message": "Din nuvarande plan har en gräns för antalet inbjudningar du kan skicka per dag.",
  "plan.errors.invitationsLimit.solution": "För att skicka fler inbjudningar, uppgradera din plan till PRO.",
  "plan.errors.messagesLimit.title": "Meddelandegränsen nådd",
  "plan.errors.messagesLimit.message": "Din nuvarande plan har en gräns för hur många meddelanden du kan skicka per dag.",
  "plan.errors.messagesLimit.solution": "För att skicka fler meddelanden, uppgradera din plan till PRO.",
  "plan.errors.storageLimit.title": "Lagringsgränsen nådd",
  "plan.errors.storageLimit.message": "Din nuvarande prenumeration har en gräns för mängden tillgängligt lagringsutrymme.",
  "plan.errors.storageLimit.solution": "För mer lagring, uppgradera till PRO.",
  "plan.errors.chatsLimit.title": "Konversationsgränsen nådd",
  "plan.errors.chatsLimit.message": "Din nuvarande plan har en gräns för antalet konversationer du kan ha.",
  "plan.errors.chatsLimit.solution": "För att skapa fler konversationer, uppgradera din plan till PRO.",
  "plan.errors.upgradeRequired.title": "Planuppgradering krävs",
  "plan.errors.upgradeRequired.message": "Den här funktionen kräver en högre plan än den du har för närvarande.",
  "plan.errors.upgradeRequired.solution": "Uppgradera din plan till PRO för att få tillgång till den här funktionen.",
  "appearance.theme.system": "System",
  "appearance.theme.corporate": "Företags",
  "theme.system": "System",
  "theme.corporate": "Företags",
  "founder.modalClose": "Nära",
  "founder.activeCountLabel": "Aktiva grundare",
  "founder.urgency.lastSlots": "Last Founder platser tillgängliga",
  "founder.positionLabel": "Grundare #{position} / {limit}",
  "founder.leaderboard.title": "Toppgrundare",
  'auth.tagline': 'Kraften i att bli förstådd, oavsett språk',
  'auth.sign_in': 'Logga in',
  'auth.create_account': 'Skapa konto',
  'ui.search_contact': 'Sök kontakt...',
  'ui.language': 'Språk',
  "profile.users": "Användare",
  "profile.settings": "Konfiguration",
  "profile.appearance": "Utseende",
  "contacts.mode": "Läge",
  "contacts.sent": "Skickat",
  "contacts.actions": "Åtgärder",
  "contacts.pending": "Örhänge",
  "contacts.available": "Tillgänglig",
  "contacts.invited_registered": "Gäst - Registrerad",
  "table.email": "E-post",
  "table.language": "Språk",
  "table.mode": "Läge",
  "table.status": "Ange",
  "table.sent": "Skickat",
  "table.actions": "Åtgärder",
  "admin.access_denied.message": "Meddelande",
  "admin.access_denied.title": "Titel",
  "admin.action.change_plan": "Ändra plan",
  "admin.action.reactivate": "Återaktivera",
  "admin.action.suspend": "Uppskjuta",
  "admin.action.view": "Se",
  "admin.confirm.change_plan.message": "Meddelande",
  "admin.confirm.change_plan.title": "Titel",
  "admin.confirm.suspend.message": "Meddelande",
  "admin.confirm.suspend.title": "Titel",
  "admin.details.created": "Skapad",
  "admin.details.current_plan": "Nuvarande plan",
  "admin.details.domain": "Domän",
  "admin.details.last_activity": "Sista aktiviteten",
  "admin.details.name": "Jams",
  "admin.details.plan": "Planera",
  "admin.details.status": "Status",
  "admin.details.subscription": "Prenumeration",
  "admin.details.tenant_id": "Hyresgäst ID",
  "admin.details.tenant_info": "Hyresgäst info",
  "admin.details.usage": "Användande",
  "admin.error.change_plan": "Ändra plan",
  "admin.error.generic": "Generisk",
  "admin.error.load_details": "Ladda detaljer",
  "admin.error.load_tenants": "Ladda hyresgäster",
  "admin.error.reactivate": "Återaktivera",
  "admin.error.suspend": "Uppskjuta",
  "admin.error.title": "Titel",
  "admin.filter.active": "Aktivera",
  "admin.filter.all_plans": "Alla planer",
  "admin.filter.all_status": "All status",
  "admin.filter.suspended": "Uppskjuta",
  "admin.limit.devices": "Enheter",
  "admin.limit.invitations": "Inbjudningar",
  "admin.limit.messages": "meddelanden",
  "admin.limit.storage": "Lagring",
  "admin.limit.users": "Användare",
  "admin.loading": "Belastning",
  "admin.no_tenants": "Icke-hyresgäster",
  "admin.plan.enterprise": "Enterprise",
  "admin.plan.free": "Free",
  "admin.plan.pro": "Pro",
  "admin.status.active": "Aktivera",
  "admin.status.suspended": "Uppskjuta",
  'admin.subscription.id': 'Id',
  "admin.subscription.last_payment": "Sista betalningen",
  "admin.subscription.status": "Status",
  "admin.subtitle": "Texta",
  "admin.success.plan_changed": "Planen ändrad",
  "admin.success.tenant_reactivated": "Hyresgästen återaktiverad",
  "admin.success.tenant_suspended": "Hyresgäst avstängd",
  "admin.success.title": "Titel",
  "admin.table.actions": "Åtgärder",
  "admin.table.messages": "meddelanden",
  "admin.table.name": "Jams",
  "admin.table.plan": "Planera",
  "admin.table.status": "Status",
  "admin.table.storage": "Lagring",
  "admin.table.tenant_id": "Hyresgäst ID",
  "admin.table.users": "Användare",
  "admin.title": "Titel",
  "admin.usage.devices": "Enheter",
  "admin.usage.invitations": "Inbjudningar",
  "admin.usage.messages": "meddelanden",
  "admin.usage.storage": "Lagring",
  "admin.usage.users": "Användare",
  "auth.login": "Inloggning",
  "auth.register": "Register",
  "auth.reset_password": "återställ lösenord",
  "billing.cancel.button": "knapp",
  "billing.cancel.canceling": "Inställande",
  "billing.cancel.confirm": "Bekräfta",
  "billing.cancel.error": "Misstag",
  "billing.cancel.success": "framgång",
  "billing.character_billing.characters_used": "Tecken som används",
  "billing.character_billing.consumption_pct": "Konsumtion pct",
  "billing.character_billing.days_remaining": "Dagar kvar",
  "billing.character_billing.deletion_date": "Raderingsdatum",
  "billing.character_billing.period_start": "Periodstart",
  "billing.character_billing.renewal_date": "Förnyelsedatum",
  "billing.character_billing.title": "Titel",
  "billing.current_plan": "Nuvarande plan",
  "billing.founder_badge": "Grundarmärke",
  "billing.no_plans": "Planera inte",
  'billing.subscription.canceled': 'Canceled',
  'billing.subscription.canceled_note': 'Canceled note',
  "billing.subscription.next_payment": "Nästa betalning",
  "billing.subscription.plan": "Planera",
  'billing.subscription.price': 'Planpris',
  "billing.subscription.started": "Startade",
  "billing.subscription.status": "Status",
  "billing.subscription.mp_flow.subscribe_failed": "Abonnemanget kunde inte startas. Försök igen.",
  "billing.subscription.mp_flow.change_plan_failed": "Planen kunde inte ändras. Försök igen.",
  "billing.subscription.mp_status.pending": "Örhänge",
  "billing.subscription.mp_status.authorized": "Auktoriserad",
  "billing.subscription.mp_status.active": "Aktiv",
  "billing.subscription.mp_status.paused": "Pausad",
  "billing.subscription.mp_status.cancelled": "Avbruten",
  "billing.subscription.mp_status.inactive": "Inaktiv",
  "billing.subscription.mp_status.unknown": "En främling",
  "billing.unlimited": "Obegränsat",
  "billing.update_plan": "Uppdatera plan",
  "billing.update_plan_modal.title": "Titel",
  "billing.usage.loading": "Belastning",
  "common.accept": "Acceptera",
  "common.confirmPassword": "Bekräfta lösenord",
  'common.continue': 'Fortsätt',
  "common.error": "Misstag",
  "dashboard.upgrade.to_plan": "Att planera",
  "emoji.noResults": "Inga resultat",
  "emoji.pick": "Plocka",
  "export.restricted.message": "Meddelande",
  "export.restricted.title": "Titel",
  "export.restricted.upgrade": "Uppgradera",
  "founder.*": "*",
  "help.faq.a1": "A1",
  "help.faq.a2": "A2",
  "help.faq.a3": "A3",
  "help.faq.a4": "A4",
  "help.faq.a5": "A5",
  "help.faq.a6": "A6",
  "help.faq.a7": "A7",
  "help.faq.q1": "Q1",
  "help.faq.q2": "Q2",
  "help.faq.q3": "Q3",
  "help.faq.q4": "Q4",
  "help.faq.q5": "F5",
  "help.faq.q6": "F6",
  "help.faq.q7": "F7",
  "help.faq.title": "Titel",
  "help.howWorks.step4.point7": "Punkt 7",
  "help.message_time_context.free_vs_pro": "Gratis vs proffs",
  "help.message_time_context.point5": "Punkt 5",
  "help.plans.enterprise.benefits": "Fördelar",
  "help.plans.enterprise.description": "Beskrivning",
  "help.plans.enterprise.title": "Titel",
  "help.plans.foundation.devices": "Enheter",
  "help.plans.free.description": "Beskrivning",
  "help.plans.free.devices": "Enheter",
  "help.plans.free.limits": "Gränser",
  "help.plans.free.title": "Titel",
  "help.plans.intro": "Intro",
  "help.plans.pro.benefits": "Fördelar",
  "help.plans.pro.description": "Beskrivning",
  "help.plans.pro.devices": "Enheter",
  'help.plans.pro.price': '$19 / månad',
  "help.plans.pro.title": "Titel",
  "help.plans.pro.upgrade": "Uppgradera",
  "help.plans.title": "Titel",
  "help.plans.urgent_slots_badge": "Brådskande platsmärke",
  "help.slogan.final": "Avsluta",
  "help.suggestions.point1": "Punkt 1",
  "help.suggestions.point2": "Punkt 2",
  "help.suggestions.title": "Titel",
  "invitation.already_contact_added": "Kontakt har redan lagts till",
  "invitation.already_contact_title": "Har redan kontaktat titeln",
  "invitation.already_pending": "Redan väntande",
  "invitation.language.invalid": "Ogiltig",
  "message.send": "Skicka",
  "message.sendFile": "Skicka fil",
  "messages.conversations": "Samtal",
  "messages.no_conversations_subtitle": "Inga undertexter för konversationer",
  "messages.no_conversations_title": "Ingen konversationstitel",
  "presence.custom.edit": "Redigera",
  "profile.enrichment.country": "land",
  "profile.enrichment.country.select": "Välja",
  "profile.enrichment.description": "Beskrivning",
  "profile.enrichment.org_size": "Organisationsstorlek",
  "profile.enrichment.org_size.placeholder": "platshållare",
  "profile.enrichment.save": "Spara",
  "profile.enrichment.skip": "hoppa",
  "profile.enrichment.title": "Titel",
  "profile.enrichment.usage_type.label": "Märka",
  "profile.enrichment.usage_type.placeholder": "platshållare",
  "profile.founderPosition": "GrundarePosition",
  "settings.confirmations.description": "Beskrivning",
  "settings.confirmations.disable": "Inaktivera",
  "settings.confirmations.title": "Titel",
  "settings.confirmations.updated": "Uppdaterad",
  "settings.title": "Titel",
  "theme.description": "Beskrivning",
  "google.unavailable_tenant": "Google är inte tillgängligt för den här hyresgästen.",
  "google.unavailable": "Google är inte tillgängligt.",
  "google.verify_client_id": "Verifiera klient-id:t i Google Cloud Console.",
  'google.login_aria': 'Logga in med Google',
  "message.preview_alt": "Förhandsvisning",
  "message.image_attachment_alt": "Bifogad bild",
  "profile.avatar.alt": "avatar",
  "plan.name.free": "FREE",
  "plan.name.pro": "PRO",
  "plan.name.foundation": "FOUNDATION",
  "plan.name.enterprise": "ENTERPRISE",
  "register.emailPlaceholder": "you@email.com",
  "invitation.top.loading": "Läser in de bästa inbjudarna...",
  "invitation.top.empty": "Inga utvalda inbjudare än.",
  "invitation.contacts.title": "Bjud in kontakter",
  "invitation.contacts.safe_phase_note": "Säker fas aktiv: väntande förmåner utan inverkan på verkliga gränser.",
  "invitation.contacts.generate_code": "Generera kod/länk",
  "invitation.contacts.refresh_top3": "Uppdatera topp 3",
  "invitation.contacts.hide_full_ranking": "Dölj hela rankningen",
  "invitation.contacts.show_full_ranking": "Visa hela rankningen",
  "invitation.contacts.hide_metrics_dashboard": "Dölj instrumentpanelen för mätvärden",
  "invitation.contacts.show_metrics_dashboard": "Visa instrumentpanelen för mätvärden",
  "invitation.contacts.prepared_link_label": "Förberedd länk:",
  "invitation.contacts.email_placeholder": "email@domain.com",
  "invitation.contacts.register_pending": "Registrera väntande inbjudan",
  "invitation.contacts.status_summary": "Statusöversikt",
  "invitation.contacts.sent_invitations": "Skickade inbjudningar",
  "invitation.contacts.invited_email": "Inbjudet e-postmeddelande",
  "invitation.contacts.code": "koda",
  "invitation.contacts.no_sent_invitations": "Jag har inte skickat inbjudningar än.",
  "invitation.contacts.simulated_rewards": "Simulerade belöningar erhållna",
  "invitation.contacts.no_simulated_rewards": "Inga simulerade belöningar ännu.",
  "common.id": "ID",
  "common.created": "Skapad",
  "plan.pro_contacts": "Hasta 100 contactos por usuario",
  "common.status": "Status",
  'login.prompt_create_account_with_name': 'Vill du skapa ett konto med detta namn?',
  'auth.pending_activation.title': 'Konto väntar på aktivering',
  'auth.pending_activation.body': 'Ditt konto är inte aktiverat ännu. Kontrollera inkorgen och bekräfta din registrering för att logga in på ArChat.',
  'auth.pending_activation.back_to_login': 'Tillbaka till inloggning',
  'auth.pending_activation.support_prefix': 'Behöver du hjälp? Kontakta support:',
  "auth.pending_activation.support_email": "info@archat.com.ar",
  'auth.pending_activation.email_label': 'E-post för att skicka aktivering igen',
  'auth.pending_activation.email_placeholder': 'du@email.com',
  'auth.pending_activation.email_required': 'Ange den e-post du registrerade dig med för att skicka aktivering igen.',
  'auth.pending_activation.sent_title': 'Aktiveringsmejl skickat',
  'auth.pending_activation.sent_body': 'Om adressen matchar ett väntande konto har vi skickat en ny aktiveringslänk. Kontrollera inkorgen och skräppost.',
  'auth.pending_activation.soft_error_title': 'Det går inte att skicka igen just nu',
  'auth.pending_activation.soft_error_body': 'Vi kunde inte hantera omsändningen nu. Försök igen om några minuter eller kontakta oss på info@archat.com.ar.',
  'auth.pending_activation.resend_again': 'Skicka igen',
  'plans.upgrade.title': 'Uppgradera plan',
  'plans.upgrade.comparison': 'Planjämförelse',
  'plans.upgrade.billing': '',
  'plans.upgrade.cancel_anytime': 'Avsluta när du vill',
  'plans.actions.upgrade_pro': 'Uppgradera till PRO',
  'plans.actions.become_founder': 'Bli Founder',

  'plans.modal.card.current_badge': 'Ditt nuvarande abonnemang',

  'plans.modal.card.lower_tier': 'Under ditt aktiva abonnemang',

  'plans.modal.card.manage_in_profile': 'För att ändra eller säga upp: Prenumeration och fakturering i din profil.',
                'plans.modal.card.cancel_subscription': 'Avsluta prenumeration',
                'plans.modal.cancel_confirm.title': 'Avsluta eller hantera prenumeration',
                'plans.modal.cancel_confirm.body': 'En ny flik öppnar Paddle-portalen där du kan uppdatera betalning, fakturor eller avsluta prenumerationen.',
                'plans.modal.cancel_confirm.continue_button': 'Fortsätt',
                'plans.modal.cancel_confirm.back_button': 'Tillbaka',
                'plans.modal.cancel_paddle_fallback.title': 'Hantera din prenumeration',
                'plans.modal.cancel_paddle_fallback.body': 'Paddle-portalen öppnas inte i den här miljön (t.ex. lokal utveckling eller ej kopplat konto). Du kan fortfarande se och jämföra planer här.',
                'plans.modal.cancel_paddle_fallback.confirm': 'OK',
  "plans.upgrade_required": "Finns i PRO-plan",
  'settings.heading': 'Inställningar',
  'settings.dashboard': 'Instrumentpanel',
  'settings.dashboardDescription': 'Lokala inställningar för startpanelen och synliga block.',
  'settings.dashboardGridHeading': 'Panelblock',
  'settings.dashboardShowOnStartDescription': 'När på öppnas panelen efter inloggning i stället för kontaktlistan.',
  'settings.dashboardBlockWelcome': 'Välkommen',
  'settings.dashboardBlockUsage': 'Plånutnyttjande',
  'settings.dashboardBlockFiles': 'Mina filer',
  'settings.dashboardBlockPromotions': 'Kampanjer',
  'settings.dashboardBlockSessions': 'Sessioner',
  'settings.dashboardWelcomeDescription': 'Första steg, bjud in kontakt och hjälpsnarvägar.',
  'settings.dashboardUsageDescription': 'Användning mot gränser: kontakter, tecken, lagring, enheter.',
  'settings.dashboardFilesDescription': 'Sammanfattning av filer och utrymme i Mina filer.',
  'settings.dashboardPromotionsDescription': 'Kampanjöversikt och länk till programmet.',
  'settings.dashboardSessionsDescription': 'Aktiva sessioner och enheter; stäng andra där det går.',
  'settings.enabled': 'På',
  'settings.disabled': 'Av',
  'settings.showDashboardOnStart': 'Visa panel vid inloggning',
  'settings.showWelcomeBlock': 'Välkomstkort',
  'settings.showPromotionsBlock': 'Kampanjkort',
  'settings.showUsageBlock': 'Plånutnyttjande',
  'settings.showRecentConversationsBlock': 'Visa senaste konversationer (sista meddelandet per kontakt)',
  'settings.showSessionsBlock': 'Aktiva sessioner',
  'settings.showFilesBlock': 'Filsammanfattning',
  'settings.dashboardLocalNote': 'Dessa val sparas i webbläsaren tills en profil-API finns.',
  'settings.appearanceSettings': 'Utseende',
  'settings.argentinaTheme': 'Argentina-tema',
  'settings.darkMode': 'Mörkt läge',
  'settings.language': 'Språk',
  'settings.messageSound': 'Meddelandeljud',
  'settings.playSoundDescription': 'Spela upp ett ljud för nya meddelanden eller viktiga aviseringar.',
  'settings.messageSoundEnabled': 'På',
  'settings.messageSoundDisabled': 'Av',
  'settings.accountSettings': 'Konto',
  'settings.deleteAccount': 'Radera konto',
  'settings.deleteAccountWarning': 'Detta är permanent. Dina data, meddelanden, kontakter och inställningar tas bort enligt plattformens raderingsprocess.',
  'settings.deleteMyAccount': 'Radera mitt konto',
  'dashboard.contacts': 'Kontakter',
  'dashboard.characters': 'Tecken',
  'dashboard.storage': 'Lagring',
  'dashboard.active_devices': 'Aktiva enheter',
  'dashboard.need_more_resources': 'Behöver du fler resurser?',
  'dashboard.upgrade_message': 'Uppgradera din plan för att få fler kontakter, tecken, lagring och aktiva enheter.',
  'dashboard.upgrade_button': 'Uppgradera till PRO',
  'dashboard.upgrade_button_pro': 'Uppgradera till PRO',
  'dashboard.upgrade_button_foundation': 'Uppgradera till FOUNDATION',
  'files.preview': 'Förhandsgranskning',
  'files.previewFile': 'Förhandsgranska fil',
  'files.previewUnavailable': 'Förhandsgranskning är inte tillgänglig.',
  'files.previewLoading': 'Laddar förhandsgranskning…',
  'files.openPreview': 'Förhandsgranska',
  'files.downloadFile': 'Ladda ner fil',
  'files.downloadFailed': 'Filen kunde inte laddas ner. Kontrollera anslutning och session och försök igen.',
  'files.closePreview': 'Stäng förhandsgranskning',
  'files.unsupportedPreview': 'Ingen förhandsgranskning för denna filtyp. Du kan se uppgifter eller ladda ner.',
  'files.pdfPreviewHelp': 'Webbläsaren kanske inte visar inbäddad PDF. Ladda ner för att öppna.',
  'files.labelFileType': 'Typ',
  'files.previewForbidden': 'Inget tillstånd att förhandsgranska.',
  'files.previewNotFound': 'Filen är inte tillgänglig eller syns inte längre i ditt konto.',
  'files.unavailableForFree': 'Mina filer ingår inte i FREE-planen.',
  'files.availableInFoundationAndPro': 'Mina filer finns i FOUNDATION och PRO.',
  'files.filesFeatureRestricted': 'Funktionen är inte tillgänglig i ditt nuvarande abonnemang.',
  'files.filesLoadError': 'Fel vid inläsning av filer.',
  'files.uploadUnavailableForFree': 'Att skicka filer är inte tillgängligt i FREE.',
  'files.uploadAvailableInFoundationAndPro': 'Uppladdning av filer finns i FOUNDATION och PRO.',
  'files.recipientStorageFull': 'Mottagaren har ingen ledig plats att ta emot den här filen.',
  'files.recipientNoAvailableStorage': 'Mottagaren har ingen ledig plats att ta emot den här filen.',
  'files.storageQuotaExceeded': 'Du har nått lagringsgränsen för ditt abonnemang.',
  'files.freeStorageLimit': 'FREE-abonnemanget inkluderar 5 MB lagring för mottagna filer.',
  'settings.unreadEmailReminderSection': 'E-post med olästa sammanfattning',
  'settings.unreadEmailReminderDescription': 'Om du lämnar nya meddelanden eller filer olästa längre än tiden nedan skickar ArChat ett samlat mejl (inte ett per meddelande).',
  'settings.unreadEmailReminderToggle': 'Skicka sammanfattningar till min e-post',
  'settings.unreadEmailDelayHours': 'Väntetid före utskick (timmar)',
  'settings.unreadEmailDelayHint': '1–168 timmar (upp till en vecka). Mejlet använder språket i din profil.',
  'subjects.title': 'Ämnen',
  'subjects.singular': 'Ämne',
  'subjects.plural': 'Ämnen',
  'subjects.general': 'Allmänt',
  'subjects.new': 'Nytt ämne',
  'subjects.create': 'Skapa ämne',
  'subjects.rename': 'Byt namn',
  'subjects.finish': 'Avsluta',
  'subjects.reopen': 'Öppna igen',
  'subjects.select': 'Fortsätt',
  'subjects.status.open': 'Öppen',
  'subjects.status.pending': 'Väntande',
  'subjects.status.finished': 'Avslutad',
  'subjects.limitReached': 'Du har nått gränsen för aktiva ämnen i den här konversationen. Avsluta ett ämne för att skapa ett nytt.',
  'subjects.limitReachedFree': 'FREE-planen tillåter upp till 3 aktiva ämnen per konversation. Avsluta ett ämne för att skapa ett nytt.',
  'subjects.limitReachedPro': 'PRO-planen tillåter upp till 5 aktiva ämnen per konversation. Avsluta ett ämne för att skapa ett nytt.',
  'subjects.limitReachedFoundation': 'FOUNDATION-planen tillåter upp till 5 aktiva ämnen per konversation. Avsluta ett ämne för att skapa ett nytt.',
  'subjects.activeLimitsLine': 'Aktiva ämnen: {current} / {max}',
  'subjects.closedListTitle': 'Stängda ämnen',
  'subjects.viewClosed': 'Visa stängda ämnen',
  'subjects.noClosedSubjects': 'Det finns inga stängda ämnen.',
  'subjects.reopenSubject': 'Öppna igen',
  'subjects.reopenedSubjects': 'Återöppnade ämnen',
  'subjects.reopenLimitReached':
    'Du har nått gränsen för aktiva ämnen. Avsluta ett annat ämne för att öppna detta igen.',
  'subjects.ownerOnlyReopen': 'Endast den som skapade detta ämne kan öppna det igen.',
  'subjects.modal.title': 'Konversationens ämnen',
  'subjects.modal.subtitle': 'Välj eller hantera ämnena i den här konversationen.',
  'subjects.contactLabel': 'KONTAKT:',
  'subjects.ownerOnlyRename': 'Endast den som skapade ämnet kan byta namn.',
  'subjects.ownerOnlyStateChange': 'Endast den som skapade ämnet kan ändra status.',
  'subjects.createdByOther': 'Detta ämne skapades av den andra parten. Du kan svara men inte byta namn.',
  'subjects.empty': 'Inga ämnen att visa.',
  'subjects.noResults': 'Inga ämnen hittades.',
  'subjects.error.generic': 'Åtgärden kunde inte slutföras. Försök igen.',
  'subjects.error.featureDisabled': 'Ämnen är inte tillgängliga i den här miljön.',
  'subjects.error.duplicateName': 'Det finns redan ett aktivt ämne med det namnet.',
  'subjects.error.ownerRequired': 'Du har inte behörighet att ändra detta ämne.',
  'subjects.error.defaultCannotRename': 'Ämnet Allmänt kan inte byta namn.',
  'subjects.error.defaultCannotFinish': 'Ämnet Allmänt kan inte avslutas.',
  'subjects.current': 'Ämne',
  'subjects.change': 'Byt ämne',
  'subjects.currentLabel': 'Ämne:',
  'subjects.changeSubject': 'Byt ämne',
  'subjects.closedCannotSend': 'Detta ämne är avslutat. Öppna det igen för att skicka nya meddelanden.',
  'subjects.selectBeforeSend': 'Välj ett ämne i dialogrutan för att visa meddelanden och skicka.',
  'subjects.loadingMessages': 'Laddar meddelanden för detta ämne…',
  'subjects.messageFilterError': 'Vi kunde inte ladda meddelanden för detta ämne.',
  ...PRESET_LOCALES.sv,
  "auth.login.clear_password_lock_after_reset": "Jag har redan ändrat mitt lösenord (t.ex. på en annan enhet)",
  "auth.signup_disabled": "Registrering av nya konton är tillfälligt inaktiverad i den här miljön.",
  "auth.reset_user_not_found": "Vi hittade inget konto kopplat till det e-postmeddelandet. Kontrollera att det är rättstavat eller skapa ett nytt konto.",
  "account.not_found": "Kontot hittades inte.",
  "menu.plans": "Planer",
  "files.title": "mina filer",
  "files.filter_all": "Alla",
  "files.filter_sent": "Skickat",
  "files.filter_received": "Mottagen",
  "files.filter_images": "Bilder",
  "files.filter_documents": "Dokument",
  "files.col_name": "Namn",
  "files.col_size": "Storlek",
  "files.col_date": "Datum",
  "files.col_direction": "Dir.",
  "files.col_actions": "Åtgärder",
  "files.sent": "📤 Skickat",
  "files.received": "📥 Mottaget",
  "files.download": "Ansvarsfrihet",
  "files.delete_for_me": "Ta bort åt mig",
  "files.delete_confirm_title": "Ta bort fil",
  "files.delete_confirm_message": "Den här filen kommer att raderas från ditt konto. Det kommer inte att raderas för den andra personen. Fortsätta?",
  "files.empty": "Du har inga filer.",
  "files.error_loading": "Det gick inte att ladda upp filer.",
  "files.load_more": "Ladda mer",
  "message.status.sending": "Sändning…",
  "message.status.failed": "Ej skickat",
  "message.status.sent": "Skickat",
  "message.status.delivered": "Levereras",
  "message.status.read": "Läsa",
  "home.public_nav.pricing": "Priser",
  "home.public_nav.aria": "Huvudsida navigering",
  "home.public_footer.aria": "Juridiska länkar",
  "home.pricing_link": "Planer och priser",
  "publicPricing.nav.back_home": "← Hem",
  "publicPricing.title": "Planer och priser",
  "publicPricing.subtitle": "Transparenta och anpassade gränser för ArChat-prenumerationsmotorn. Kommersiella priser i USD för internationell utcheckning (t.ex. Paddle).",
  "publicPricing.commercial_note": "Funktionella gränser kommer från PlanConstants/PlanResolver; ditt konto kan tillämpa plan_limits i databasen. Säljardebitering använder Paddle (eller andra processorer officiellt utsedda av ArChat) med USD-pris enligt indikation.",
  "publicPricing.plan.free": "FREE",
  "publicPricing.plan.foundation": "FOUNDATION",
  "publicPricing.plan.pro": "PRO",
  "publicPricing.price.free": "USD 0 / mes",
  "publicPricing.price.foundation": "USD {price} / mes",
  "publicPricing.price.pro": "USD {price} / mes",
  "publicPricing.same_limits_pro": "Samma tekniska gränser som PRO (premiumkontrakt).",
  "publicPricing.same_limits_foundation": "Samma tekniska gränser som FOUNDATION (premiumkontrakt).",
  "publicPricing.badge.foundation": "Programa Founder",
  "publicPricing.badge.pro": "Recomendado",
  "publicPricing.free.b1": "30 000 tecken per månad och konto.",
  "publicPricing.free.b2": "Upp till 2 kontakter per användare; upp till 2 aktiva konversationer per konto.",
  "publicPricing.free.b3": "Inga bilagor eller lagringsutrymme; utan dataexport.",
  "publicPricing.free.b4": "Meddelandehistorik upp till 30 dagar; 1 enhet per användare.",
  "publicPricing.free.b5": "34 meddelanden/dag och 1 000 meddelanden/månad (hyresgäst); upp till 20 inbjudningar per dag.",
  "publicPricing.premium.b1": "300 000 tecken per månad och konto; upp till 100 kontakter per användare.",
  "publicPricing.premium.b2": "Obegränsade konversationer och chattar (hyresgäst); 1 667 meddelanden/dag och 50 000/månad.",
  "publicPricing.premium.b3": "Upp till 50 MB lagringsutrymme (hyresgäst); upp till 3 enheter per användare.",
  "publicPricing.premium.b4": "Obegränsade inbjudningar (hyresgäst); export, automatisk översättning och filer enligt plan.",
  "publicPricing.premium.b5": "FOUNDATION: samma tekniska kontrakt som PRO, plus Founder-program (150 platser). PRO: premium standard.",
  "publicPricing.foundation.founder_note": "Grundarens kommersiella program: begränsat antal {slots} platser (se planöversikten). Samma PRO-gränser när prenumerationen är aktiverad.",
  "publicPricing.cta.start_free": "Skapa ett gratis konto",
  "publicPricing.cta.register_paid": "Skapa konto",
  "publicPricing.paddle_hint": "Utcheckning med den valda processorn kommer att slutföras i applikationen när laddning är aktiverad.",
  "publicPricing.legal.nav_label": "Rättslig",
  "publicPricing.legal.terms": "Användarvillkor",
  "publicPricing.legal.privacy": "Sekretesspolicy",
  "publicPricing.legal.refund": "Återbetalningspolicy",
  "profile.security.privacy_note": "Hantera integriteten och säkerheten för ditt konto.",
  "profile.security.sessions_title": "Aktiva sessioner",
  "profile.security.current": "Aktuell session",
  "profile.plan.foundation.description": "FOUNDATION Plan (Founder): samma premiumanvändning som PRO, med Founder-program och begränsat utrymme (150 platser).",
  "billing.view_plans": "Se planer",
  "billing.paddle.cancel_via_portal": "Avsluta prenumerationen",
  "billing.paddle.test_access_denied_body": "På den här servern är faktureringsoperationer begränsade (testläge eller testlista). Om du redan har betalat med ett riktigt konto måste betalningen i produktion tillåtas för alla användare (t.ex. PAYMENTS_ALLOW_ALL_BILLING_USERS) eller så måste begränsningen inaktiveras. Kontakta supporten.",
  "attachment.storage_insufficient_precheck.title": "Otillräckligt utrymme",
  "attachment.storage_insufficient_precheck.message": "Filen väger {fileSizeMb} MB och du har bara {availableMb} MB tillgänglig. Frigör utrymme eller förbättra din plan för att fortsätta.",
  "attachment.files_disabled.title": "Plangräns",
  "attachment.files_disabled.message": "Din nuvarande plan inkluderar inte filsändning. Förbättra din plan för att fortsätta.",
  "contacts.viewContactInfo": "Visa kontaktuppgifter",
  "contacts.contactInfoTitle": "Kontaktuppgifter",
  "contacts.phone": "Telefon",
  "contacts.bio": "Biografi",
  "contacts.notProvided": "Oinformerad",
  "contacts.unread.badge": "Olästa meddelanden",
  "dashboard.recentInbound.title": "Senast mottagna meddelanden",
  "dashboard.recentInbound.empty": "Du har inga nyligen mottagna meddelanden.",
  "dashboard.recentInbound.error": "Meddelanden kunde inte laddas.",
  "dashboard.recentInbound.previewPhoto": "Bild",
  "dashboard.recentInbound.previewFile": "Arkiv",
  "dashboard.recentInbound.previewPdf": "PDF",
  "dashboard.recentInbound.previewUnavailable": "Meddelandet är inte tillgängligt",
  "dashboard.recentInbound.readTitle": "Läsa",
  "dashboard.recentInbound.unreadTitle": "oläst",
  "dashboard.recentConversations.title": "De senaste samtalen",
  "dashboard.recentConversations.empty": "Det finns inga konversationer att visa.",
  "dashboard.recentConversations.error": "Det gick inte att läsa in konversationer.",
  "dashboard.plan.foundation": "FOUNDATION",
  "plan.errors.translationNotAllowed.title": "Översättning inte tillgänglig",
  "plan.errors.translationNotAllowed.message": "Din nuvarande plan inkluderar inte automatisk översättning mellan språk.",
  "plan.errors.translationNotAllowed.solution": "Uppgradera din plan för att använda automatisk översättning.",
  "billing.subscription.cancel_scheduled_date": "Din prenumeration är planerad att avslutas den {{date}}. Du kan fortsätta använda din plan tills dess.",
  "billing.subscription.cancel_scheduled_badge": "Avbröt den {{date}}",
  "billing.scheduled.plan_after_cancel_label": "Planera i slutet av perioden:",
  "billing.scheduled.plan_free": "FREE (gratuito)",
  "billing.scheduled.plan_foundation": "FOUNDATION",
  "billing.scheduled.switch_to_foundation": "Byt till FOUNDATION",
  "billing.scheduled.switch_to_free": "Byt till GRATIS",
  "billing.scheduled.foundation_full_title": "FOUNDATION inte tillgänglig",
  "billing.scheduled.foundation_full_message": "Det finns inga FOUNDATION-platser tillgängliga just nu. Din plan kommer att gå ner till GRATIS i slutet av perioden.",
  "billing.scheduled.saving": "Sparande...",
  "billing.scheduled.error_title": "Fel vid ändring av plan",
  "billing.scheduled.error_generic": "Den planerade planen kunde inte ändras. Försök igen.",
  "billing.cancel_scheduled.title": "Schemalagd avbokning",
  "billing.cancel_scheduled.desc": "Din prenumeration kommer att avslutas den {{date}}. Du kan fortsätta använda din nuvarande plan tills dess.",
  "billing.cancel_scheduled.no_new_plan_until_end": "Förrän denna prenumeration går ut kommer du inte att kunna teckna ett annat abonnemang.",
  "billing.cancel_scheduled.free_fallback": "Om du inte förnyar någon plan kommer ditt konto att fortsätta vara GRATIS med motsvarande begränsningar.",
  "billing.cancel_scheduled.profile_deactivation_hint": "Du kan också avregistrera dig från plattformen från din profil.",
  "billing.cancel_scheduled.default_free": "I slutet av perioden: GRATIS",
  "google.missing_client_id": "Google-inloggning är inte tillgänglig i denna version: VITE_GOOGLE_CLIENT_ID (eller googleClientId per klient i __ARCHAT_TENANT_CONFIG__) saknas.",
  "reviews.title": "ArChat recensioner",
  "reviews.create_title": "Hur skulle du betygsätta ArChat?",
  "reviews.edit_title": "Redigera min recension",
  "reviews.comment_placeholder": "Berätta om din upplevelse (valfritt)...",
  "reviews.submit_btn": "Skicka recension",
  "reviews.update_btn": "Uppdatera",
  "reviews.thank_you": "Tack för din recension!",
  "reviews.submitted_message": "Din åsikt hjälper oss att förbättra oss.",
  "reviews.error_select_rating": "Välj ett betyg",
  "reviews.error_generic": "Det gick inte att skicka recension",
  "reviews.prompt_message": "Gillar du ArChat? Lämna din recension!",
  "reviews.rate_now": "Kvalificera",
  "reviews.later": "Senare",
  "reviews.write_review": "Skriv recension",
  "reviews.edit_my_review": "Redigera min recension",
  "reviews.no_reviews": "Det finns inga recensioner ännu. Bli först!",
  "reviews.review_singular": "recension",
  "reviews.review_plural": "recensioner",
  "reviews.verified": "Verifierad",
  "reviews.anonymous": "Anonym",
  "files.storageUsed": "Använd utrymme",
  "files.planQuota": "Planera kvot",
  "files.availableStorage": "Tillgänglig",
  "files.usagePercent": "begagnad",
  "files.unlimited": "Obegränsat",
  "files.sentBy": "Skickat av",
  "files.unknownUser": "Användare",
  "settings.webPushSection": "Systemaviseringar (push/PWA)",
  "settings.webPushDescription": "Tillåter aviseringar när appen är i bakgrunden eller stängd på mobilen. Kräver offentlig VAPID-nyckel i builden (VITE_VAPID_PUBLIC_KEY) och nycklar på servern. Aktivera webbläsarbehörighet och registrera den här enheten.",
  "settings.webPushButton": "Aktivera push-meddelanden",
  "settings.webPushRegistering": "Registrerar...",
  "settings.webPushState.granted": "Tillstånd beviljat. Om VAPID är korrekt inställt skickades loggen till servern.",
  "settings.webPushState.denied": "Tillstånd nekad. Vänligen aktivera aviseringar för den här webbplatsen i din webbläsarinställningar.",
  "settings.webPushState.default": "Tryck på knappen för att begära tillstånd och registrera enheten.",
  "settings.webPushState.unsupported": "Den här webbläsaren stöder inte push-meddelanden.",
  "settings.webPushVapidMissing": "VITE_VAPID_PUBLIC_KEY saknas i denna frontend-build: kan inte slutföra push-prenumeration.",
  "tags.etiquetas": "etiketter",
  "tags.manageTitle": "Hantera taggar",
  "tags.manage": "🏷️ Taggar",
  "tags.allTags": "Alla taggar",
  "tags.confirmDelete": "Vill du ta bort den här taggen?",
  "tags.tagNamePlaceholder": "Taggnamn",
  "tags.create": "Skapa",
  "tags.noTags": "Det finns inga etiketter. Skapa en ovan.",
  "tags.save": "Hålla",
  "tags.edit": "Redigera",
  "tags.delete": "Eliminera",
  "tags.assignTo": "Tilldela till",
  "tags.noTagsToAssign": "Inga etiketter tillgängliga. Skapa dem först.",
  "tags.bgColor": "bakgrundsfärg",
  "tags.textColor": "Text färg",
  "tags.selectTag": "Välj en etikett",
  "templates.selectTitle": "Mallar",
  "templates.noTemplates": "Det finns inga mallar. Skapa en ovan.",
  "templates.manage": "Hantera mallar",
  "templates.confirmDelete": "Vill du ta bort den här mallen?",
  "templates.manageTitle": "Hantera mallar",
  "templates.titlePlaceholder": "Mallens titel",
  "templates.bodyPlaceholder": "Jag skrev mallmeddelandet...",
  "templates.create": "Skapa mall",
  "templates.save": "Hålla",
  "templates.edit": "Redigera",
  "templates.delete": "Eliminera",
};


